/* eslint-disable import/no-unresolved */
import {
  Box,
  CardContent,
  FormControl,
  Grid,
  FormGroup,
  FormControlLabel,
  Checkbox,
  InputLabel,
  List,
  ListItem,
  ListItemText,
  NativeSelect,
  Tooltip,
  Typography,
  makeStyles,
  IconButton,
  colors,
  Collapse,
  Toolbar,
  Button,
} from "@material-ui/core";
import React, {
  useEffect,
  useState,
  useCallback,
  SetStateAction,
  useRef,
} from "react";
import {
  green as myGreen,
  red as myRed,
  grey as myGrey,
  yellow as myYellow,
  red as myred,
} from "@material-ui/core/colors";
import {
  Person as PersonIcon,
  PersonOutline,
  FiberManualRecord as Circle,
  ExpandMore,
  ExpandLess,
  UnfoldMore,
  UnfoldLess,
  TextFormat,
  Apps,
  Reorder,
  Fullscreen,
} from "@material-ui/icons";
import { Map as ImmutableMap } from "immutable";
import View from "./View";
import CxSidebar from "./CxSidebar";
import MeepleHeadset from "./icons/MeepleHeadset";
import CxAgent from "./CxAgent";
import CxQueueWidget from "./CxQueueWidget";
import CxQueueLeaderboard from "./CxQueueLeaderboard";
import CxAgentLeaderboard from "./CXAgentLeaderboard";
import { UserPresenceEvent } from "./QueueLeaderboard";
import CxQueueLeaderboardWaiting from "./CxQueueLeaderboardWaiting";
import CxQueueLeaderboardInProgress from "./CxQueueLeaderboardInProgress";
import CompactViewHeader from "./NEW/CompactViewHeader";

const green = {
  ...myGreen,
  1000: "rgba(144, 238, 144, 0.2)",
};

const yellow = {
  ...myYellow,
  1000: "rgba(232, 224, 63, 0.2)",
};

const red = {
  ...myRed,
  1000: "rgba(255, 204, 203, 0.2)",
};

const grey = {
  ...myGrey,
  1000: "rgb(155 155 155 / 20%)",
};

// const cxWebsocketAdress =
//   "wss://dhekjif628.execute-api.us-east-1.amazonaws.com/prod";
// const cxCallApi = `https://tmipln5lwe.execute-api.eu-west-2.amazonaws.com/ringcx-deltas`;
const cxWebsocketAdress = process.env.REACT_APP_CX_SOCKET_URL || "wss://dhekjif628.execute-api.us-east-1.amazonaws.com/prod";
const cxCallApi = `${process.env.REACT_APP_CX_API_URL || "https://5wnuftmrla.execute-api.us-east-1.amazonaws.com"}/ringcx-calls`;

const cxStatusColorGetter = (cxStatus: string | undefined) => {
  switch (cxStatus) {
    case "AVAILABLE":
      return "green";

    case "ON-BREAK":
    case "AWAY":
    case "LUNCH":
    case "OFF-LINE":
    case "UNKNOWN":
    case undefined:
      return "gray";

    case "ENGAGED":
    case "BREAK-AFTER-CALL":
    case "TRANSITION":
    case "PENDING-DISPOSITION":
    case "UNAVAILABLE":
    case "RNA-STATE":
      return "red";

    case "TRAINING":
    case "WORKING":
      return "yellow";

    default:
      return "";
  }
};

const altStatusGetter = (status: string | undefined) => {
  switch (status) {
    case "AVAILABLE":
      return `AVL:${status}`;

    case "ON-BREAK":
    case "AWAY":
    case "LUNCH":
    case "OFF-LINE":
    case "UNKNOWN":
      return `INV:${status}`;

    case "ENGAGED":
    case "BREAK-AFTER-CALL":
    case "TRANSITION":
    case "PENDING-DISPOSITION":
    case "UNAVAILABLE":
    case "RNA-STATE":
      return `BSY:${status}`;

    case "TRAINING":
    case "WORKING":
      return `UNV:${status}`;

    case undefined:
      return "";
    default:
      return "";
  }
};

interface CXAgent {
  id: string;
  agentId: number;
  groupId: string;
  groupName?: string;
  firstName?: string;
  lastName?: string;
  agentType?: string;
  stateTimestamp?: string;
  agentState?: string;
  queues?: Array<{ queueId: number; queueName?: string; login: boolean }>;
  rcUserId?: string;
  department?: string;
  site?: string;
  global?: string;
  display?: string;
  messageTimestamp?: string;
  portrait?: string;
  supervisees?: Array<{ agentId: number; agentName: string }>;
  supervisors?: Array<number>;
  activeCalls?: Array<{ phoneNumber: string; timestamp: string }>;
  ringingCalls?: Array<{ phoneNumber: string; timestamp: string }>;
  callState?: string;
}

interface CXDepartment {
  id: string;
  name: string;
}

interface CXSite {
  id: string;
  name: string;
}

interface CXSupervisor {
  id: string;
  supervisorId: number;
  agents: Array<number>;
  firstName?: string;
  lastName?: string;
}

interface CXQueue {
  id: string;
  gateGroupId: number;
  gateGroupName?: string;
  groupName?: string;
  gateId: number;
  gateName?: string;
  gateDesc?: string;
  assignedAgents?: Array<number>;
}

interface CXQueueState {
  topic: string;
  agentId: string;
  dateTime: string;
  update: Array<{ queueId: string; login: boolean }>;
}

interface CXAgentState {
  topic: string;
  agentId: string;
  dateTime: string;
  agentState: string;
  previousState?: string;
}

interface CXAgentGroup {
  id: string;
  agentGroupId: number;
  groupName?: string;
  agents: Array<number>;
}

interface CXQueueGroup {
  id: string;
  gateGroupId: number;
  groupName: string;
  queues: Array<number>;
  agents: Array<number>;
}

export interface CXExtension {
  agentDuration?: number;
  agentDisposition?: string;
  agentCount?: number;
  duration: number;
  count?: number;
  ivrDuration?: number;
  ivrCount?: number;
  queueDuration?: number;
  queueCount?: number;
  transferDuration?: number;
  transferCount?: number;
  transferDestination?: string;
  agentWrapTime?: number;
  agentWrapCount?: number;
  ringTime?: number;
  ringCount?: number;
  extensionId: string;
  extension: string;
  activeAgent?: string;
  abandonedCount?: number;
  activeCount?: number;
  waitingCount?: number;
  completedCount?: number;
  voicemailCount?: number;
  state?: string;
  timestamp?: string;
  callId: string;
  queues?: Array<string>;
  ani: string;
  dnis: string;
  callStart: string;
  activePhoneNumbers?: Map<string, { phoneNumber: string; timestamp: string }>;
  ringingPhoneNumbers?: Map<string, { phoneNumber: string; timestamp: string }>;
  toLink?: string;
  fromLink?: string;
  fromCx?: boolean;
  fromEx?: boolean;
  toCx?: boolean;
  toEx?: boolean;
  answeredCount?: number;
  answeredWaiting?: number;
  abandonedWaiting?: number;
  voicemailWaiting?: number;
  direction: string;
}

export interface CxCall {
  extensionId: string;
  extension: string;
  state: string;
  timestamp: string;
  callId: string;
  queues: string[];
  agentDisposition?: string;
  ani: string;
  dnis: string;
  callStart: string;
  callType: string;
  direction: string;
  agentCount: number;
  duration: number;
  count: number;
  queueDuration: number;
  agentWrapTime: number;
  agentWrapCount: number;
  ringTime: number;
  ringCount: number;
}

const cols = [
  "extensionId",
  "extension",
  "agentDuration",
  "agentCount",
  "duration",
  "count",
  "ivrDuration",
  "ivrCount",
  "queueDuration",
  "queueCount",
  "transferDuration",
  "transferCount",
  "agentWrapTime",
  "agentWrapCount",
  "ringTime",
  "ringCount",
  "abandonedCount",
  "activeCount",
  "waitingCount",
  "completedCount",
  "voicemailCount",
  "state",
  "answeredCount",
  "answeredWaiting",
  "abandonedWaiting",
  "voicemailWaiting",
] as Array<keyof CXExtension>;

const MAX_RETRY = 5;

const formatDuration = (time: number) => {
  if (time <= 0) {
    return "00:00";
  }
  const durationSeconds = time;
  const durationMinutes = Math.floor(durationSeconds / 60);
  const durationHours =
    durationMinutes >= 60 ? Math.floor(durationMinutes / 60) : "";
  const seconds = durationSeconds % 60;
  const minutes = durationMinutes % 60;
  return durationHours !== ""
    ? `${durationHours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`
    : `${durationMinutes.toString().padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")}`;
};

const formatApproxDuration = (sec: number) => {
  if (sec < 0) {
    return "0s";
  }
  if (sec < 60) {
    return `${sec}s`;
  }
  if (sec < 3600) {
    return `${Math.floor(sec / 60)}m`;
  }
  if (sec < 86400) {
    return `${Math.floor(sec / 3600)}h`;
  }
  return `${Math.floor(sec / 86400)}d`;
};

// Calculate elapsed time for 24hr cycle
const formatDailyDuration = (time: number) => {
  if (time < 0) {
    return "00:00";
  }

  const currentTime = new Date();
  const midnight = new Date(currentTime);
  // Reset to midnight
  midnight.setHours(0, 0, 0, 0);

  const elapsedFromMidnight = Math.floor((currentTime.getTime() - midnight.getTime()) / 1000);

  // Use smallest value between elapsed time and the provided time
  const durationSeconds = Math.min(elapsedFromMidnight, time);

  const hours = Math.floor(durationSeconds / 3600);
  const minutes = Math.floor((durationSeconds % 3600) / 60);
  const seconds = durationSeconds % 60;

  return hours > 0
    ? `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`
    : `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
}

const useStyles = makeStyles((theme) => ({
  tab: {
    textTransform: "capitalize",
    color: "white",
    "&:hover": {
      backgroundColor: "inherit",
      color: "#04587E",
    },
  },
  sidebarPanel: {
    width: "calc(100% - 10px)",
    [theme.breakpoints.up(600)]: {
      width: "calc(50% - 10px)",
    },
    [theme.breakpoints.up(900)]: {
      width: "calc(33.3333333% - 10px)",
    },
    [theme.breakpoints.up(1200)]: {
      width: "calc(25% - 10px)",
    },
    position: "fixed",
    right: 0,
    top: 0,
    height: "100%",
    color: "white",
    fontFamily: "roboto",
    overflowY: "auto",
  },
  root: {
    flexGrow: 1,
    fontFamily: "roboto",
    fontSize: "0.85rem",
    padding: 6,
    height: 85,
  },
  pos: {
    display: "flex",
    flexDirection: "column",
  },
  paper: {
    backgroundColor: "black",
  },

  widgetCellSidebar: {
    width: "calc(100% - 10px)",
    margin: 5,
    float: "left",
    [theme.breakpoints.up(0)]: {
      display: "none",
    },
    [theme.breakpoints.up(600)]: {
      width: "calc(100% - 10px)",
      display: "block",
    },
    [theme.breakpoints.up(900)]: {
      width: "calc(50% - 10px)",
    },
    [theme.breakpoints.up(1200)]: {
      width: "calc(33.3333333% - 10px)",
    },
  },
  leaderboard: {
    width: "calc(100% - 10px)",
    margin: 5,
    float: "left",
  },
  leaderboardSidebar: {
    width: "calc(100% - 10px)",
    margin: 5,
    float: "left",
    display: "none",
    [theme.breakpoints.up(600)]: {
      width: "calc(100% - 10px)",
      display: "block",
    },
  },
  nested: {
    padding: "2px 0 2px 16px",
    height: 32,
  },
  listText: {
    fontSize: "0.85rem",
  },
  widgetPanel: {
    [theme.breakpoints.up(0)]: {
      display: "none",
    },
    [theme.breakpoints.up(600)]: {
      width: "calc(50% - 10px)",
      display: "block",
    },
    [theme.breakpoints.up(900)]: {
      width: "calc(66.6666666% - 10px)",
    },
    [theme.breakpoints.up(1200)]: {
      width: "calc(75% - 10px)",
    },
    height: "100%",
  },
  body: {
    marginTop: 0,
    marginBottom: 0,
  },
  select: {
    padding: "5px 24px 5px 5px",
    border: "1px solid black",
    borderRadius: 5,
    backgroundColor: "white",
    color: "black",
    "&:focus": {
      backgroundColor: "white",
      border: "1px solid black",
      borderRadius: 5,
    },
  },
  selectDark: {
    padding: "5px 24px 5px 5px",
    border: "1px solid white",
    borderRadius: 5,
    backgroundColor: "#282828",
    color: "white",
    "&:focus": {
      backgroundColor: "#282828",
      border: "1px solid white",
      borderRadius: 5,
    },
    "& option": {
      backgroundColor: "#282828 !important",
    },
  },
  icon: {
    color: "black",
  },
  iconDark: {
    color: "white",
  },
}));

const useDarkStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    fontFamily: "roboto",
    fontSize: "0.85rem",
    padding: 6,
    height: 85,
  },
  pos: {
    display: "flex",
    flexDirection: "column",
  },
  paper: {
    backgroundColor: "white",
  },
  tab: {
    textTransform: "capitalize",
    color: "white",
    "&:hover": {
      backgroundColor: "inherit",
      color: "#808080",
    },
  },
}));

export default function CxDashboard({
  cxAgents,
  setCxAgents,
  //   cxToken,
  cxAddress,
  vipList,
  idToken,
  forwardAddress,
  mode,
  sidebar,
  historicalUsers,
  rcId,
  elapsedTime,
  tab,
  local,
  updateLocal,
  offset,
  setCxMessages,
  id,
  cxStateFilters,
  organizationId,
  isAdmin,
  apiUrl,
  origin,
  setPage,
  setProfileId,
  adminclick,
  fullscreen,
  setFullscreen,
  presenceEvents,
  activeFilterRef,
  setHistoricalUsers,
  setActiveFilterRef,
  page,
  showCXLeaderboards,
  setCxCallLog,
  cxCallLog,
}: {
  adminclick: (theId: string) => void;
  cxAddress: string;
  setProfileId: any;
  organizationId: string;
  isAdmin: boolean;
  vipList: any;
  apiUrl: string;
  cxAgents: Array<CXAgent> | undefined;
  setCxAgents: React.Dispatch<React.SetStateAction<Array<CXAgent> | undefined>>;
  //   cxToken: string;
  idToken: string;
  forwardAddress: string;
  mode: string;
  sidebar: boolean;
  historicalUsers: any;
  rcId: string;
  fullscreen: string | undefined;
  setFullscreen: React.Dispatch<SetStateAction<string | undefined>>;
  elapsedTime: string;
  id: string | undefined;
  tab: string;
  local: any;
  updateLocal: (key: any, value: any) => void;
  offset: number;
  setCxMessages: React.Dispatch<
    React.SetStateAction<Array<Array<CXExtension>>>
  >;
  setHistoricalUsers: React.Dispatch<
    React.SetStateAction<ImmutableMap<string, any>>
  >;
  setPage: React.Dispatch<React.SetStateAction<any>>;
  cxStateFilters: {
    available?: boolean;
    onbreak?: boolean;
    engaged?: boolean;
    engagedController?: boolean;
    breakAfterCall?: boolean;
    transition?: boolean;
    pendingDisposition?: boolean;
    rnaState?: boolean;
    away?: boolean;
    lunch: boolean;
    unavailable?: boolean;
    training?: boolean;
    working?: boolean;
    offline?: boolean;
    offlineController?: boolean;
    unknown?: boolean;
    setProfileId?: any;
  };
  origin: string;
  presenceEvents: Array<UserPresenceEvent>;
  setActiveFilterRef: React.Dispatch<SetStateAction<{ [colDef: string]: any }>>;
  activeFilterRef: { [colDef: string]: any };
  page: string;
  showCXLeaderboards: boolean | undefined;
  cxCallLog: CxCall[] | undefined;
  setCxCallLog: React.Dispatch<SetStateAction<CxCall[] | undefined>>;
}) {
  const [cxWs, setCxWs] = useState<WebSocket | undefined>();
  const [cxError, setCxError] = useState<boolean>(false);
  const [, setCxRetries] = useState<number>(0);

  //   const [agents, setAgents] = useState<Array<CXAgent>>([]);
  const [processingState, setProcessingState] = useState<CXAgentState>();
  const [processingQueueState, setProcessingQueueState] =
    useState<CXQueueState>();
  const [processingExPresence, setProcessingExPresence] =
    useState<UserPresenceEvent>();
  //   console.log("users", users);
  const [cxStateEvents, setCxStateEvents] = useState<Array<CXAgentState>>([]);
  const [cxQueueStateEvents, setCxQueueStateEvents] = useState<
    Array<CXQueueState>
  >([]);
  const [agentsLoaded, setAgentsLoaded] = useState<boolean>(false);
  const [colorWeight, setColorWeight] = useState<600 | 300>(600);
  const [backgroundWeight, setBackgroundWeight] = useState<100 | 1000>(100);
  const [color, setColor] = useState<"initial" | "white">("initial");
  const [borderColors, setBorderColors] = useState<
    | { green: "green"; red: "red"; grey: "grey" }
    | { green: "lightgreen"; red: "lightcoral"; grey: "lightgrey" }
  >({ green: "green", red: "red", grey: "grey" });
  const [backgroundColor, setBackgroundColor] = useState<string>("#0684bd");

  const [agentGroups, setAgentGroups] = useState<Array<CXAgentGroup>>([]);
  const [queueGroups, setQueueGroups] = useState<Array<CXQueueGroup>>([]);
  const [queues, setQueues] = useState<Array<CXQueue>>([]);
  const [userSortField, setUserSortField] = useState<string>("first-name");
  const [userSortOrder, setUserSortOrder] = useState<1 | -1>(1);

  const [queueSortField, setQueueSortField] = useState<string>("name");
  const [queueSortOrder, setQueueSortOrder] = useState<1 | -1>(1);

  const [agentGroupSortOrder, setAgentGroupSortOrder] = useState<1 | -1>(1);
  const [queueGroupSortOrder, setQueueGroupSortOrder] = useState<1 | -1>(1);
  const [blockedUsers, setBlockedUsers] = useState<Set<string>>(new Set());
  const [blockedQueues, setBlockedQueues] = useState<Set<string>>(new Set());
  const [blockedAgentGroups, setBlockedAgentGroups] = useState<Set<string>>(
    new Set()
  );
  const [blockedQueueGroups, setBlockedQueueGroups] = useState<Set<string>>(
    new Set()
  );
  const [excludedUsers, setExcludedUsers] = useState<Set<string>>(new Set());
  const [excludedQueues, setExcludedQueues] = useState<Set<string>>(new Set());
  const [excludedAgentGroups, setExcludedAgentGroups] = useState<Set<string>>(
    new Set()
  );
  const [excludedQueueGroups, setExcludedQueueGroups] = useState<Set<string>>(
    new Set()
  );
  const [showNoQueues, setShowNoQueues] = useState<boolean>(true);

  const [showAvailable, setShowAvailable] = useState<boolean>(true);
  const [showEngaged, setShowEngaged] = useState<boolean>(true);
  const [showBreakAfterCall, setShowBreakAfterCall] = useState<boolean>(true);
  const [showTransition, setShowTransition] = useState<boolean>(true);
  const [showPendingDisp, setShowPendingDisp] = useState<boolean>(true);

  const [showOnBreak, setShowOnBreak] = useState<boolean>(true);
  const [showAway, setShowAway] = useState<boolean>(true);
  const [showLunch, setShowLunch] = useState<boolean>(true);
  const [showTraining, setShowTraining] = useState<boolean>(true);
  const [showWorking, setShowWorking] = useState<boolean>(true);
  const [showRna, setShowRna] = useState<boolean>(true);

  const [showUnknown, setShowUnknown] = useState<boolean>(true);
  const [showOffline, setShowOffline] = useState<boolean>(true);

  const [visibleAgents, setVisibleAgents] = useState<Array<CXAgent>>([]);
  const [departments, setDepartments] = useState<Array<CXDepartment>>([]);
  const [sites, setSites] = useState<Array<CXSite>>([]);
  const [excludedDepartments, setExcludedDepartments] = useState<Set<string>>(
    new Set()
  );
  const [blockedDepartments, setBlockedDepartments] = useState<Set<string>>(
    new Set()
  );
  const [departmentSortOrder, setDepartmentSortOrder] = useState<1 | -1>(1);
  const [excludedSites, setExcludedSites] = useState<Set<string>>(new Set());
  const [blockedSites, setBlockedSites] = useState<Set<string>>(new Set());
  const [siteSortOrder, setSiteSortOrder] = useState<1 | -1>(1);
  const [showAgentType, setShowAgentType] = useState<boolean>(true);
  const [showSupervisorType, setShowSupervisorType] = useState<boolean>(true);
  const [extensions, setExtensions] = useState<Array<CXExtension>>([]);
  const [rowData, setRowData] = useState<
    Array<{ extension: CXExtension | undefined; agent: CXAgent }> | undefined
  >();
  const [waitingCalls, setWaitingCalls] = useState<
    Map<string, CXExtension & { ended?: boolean }>
  >(new Map());
  const [activeCalls, setActiveCalls] = useState<
    Map<string, CXExtension & { ended?: boolean }>
  >(new Map());
  const [inProgressRowData, setInProgressRowData] = useState<
    Array<CXExtension & { agentName: string }>
  >([]);
  const [expandedLeaderboard, setExpandedLeaderboard] = useState<boolean>(true);
  const [fontSize, setFontSize] = useState<string>("small");
  const [height, setHeight] = useState<number>(50);

  const [supervisors, setSupervisors] = useState<Array<CXSupervisor>>([]);
  const [showUnsupervised, setShowUnsupervised] = useState<boolean>(true);
  const [excludedSupervisors, setExcludedSupervisors] = useState<Set<string>>(
    new Set()
  );
  const [blockedSupervisors, setBlockedSupervisors] = useState<Set<string>>(
    new Set()
  );
  const [supervisorSortOrder, setSupervisorSortOrder] = useState<1 | -1>(1);
  const [supervisorSortField, setSupervisorSortField] =
    useState<string>("first-name");
  const [expandedCxAgentLeaderboard, setExpandedCxAgentLeaderboard] =
    useState<boolean>(true);
  const [expandedCxQueueLeaderboard, setExpandedCxQueueLeaderboard] =
    useState<boolean>(true);
  const [checkedQueues, setCheckedQueues] =
    useState<Set<number | string | undefined>>();
  const [expandQueues, setExpandQueues] = useState<boolean>(true);
  const [expandAgents, setExpandAgents] = useState<boolean>(true);
  const [longestWaiting, setLongestWaiting] = useState<Map<string, any>>(
    new Map()
  );
  const [cxCallsInProgress, setCxCallsInProgress] = useState<
    Map<
      string,
      Array<{
        id: string;
        phoneNumber: string;
        timestamp: string;
      }>
    >
  >(new Map());
  const [displayPortraits, setDisplayPortraits] = useState(true);
  const [me, setMe] = useState<CXAgent | undefined>();
  const [lastKnownCXstatus, setLastKnownCXStatus] = useState<any | undefined>();
  const classes = mode === "light" ? useStyles(mode) : useDarkStyles(mode);
  const [selectedLeaderboard, setSelectedLeaderboard] = useState<
    "summary" | "waiting" | "inProgress" | undefined
  >("summary");

  const getCxCalls = () => {
    if (idToken) {
      (async () => {
        const startTime = new Date();
        startTime.setHours(0, 0, 0, 0);
        const res = await fetch(
          `${cxCallApi}?startTime=${startTime.toISOString()}`,
          {
            method: "get",
            headers: {
              authorization: idToken,
              "Content-Type": "application/json",
            },
          }
        );
        const data = await res.json();
        setCxCallLog(
          data.messages?.filter(
            (message: any) =>
              message.extensionId.toString() === me?.agentId.toString()
          )
        );
      })();
    }
  };

  useEffect(() => {
    if (idToken && me) {
      getCxCalls();
    }
  }, [idToken, me]);

  useEffect(() => {
    const lastLeaderboard =
      localStorage.getItem("cx-selected-leaderboard") || "summary";
    localStorage.setItem("cx-selected-leaderboard", lastLeaderboard);
    if (lastLeaderboard) {
      setSelectedLeaderboard(
        lastLeaderboard as "summary" | "waiting" | "inProgress"
      );
    }
    if (!lastLeaderboard) {
      setSelectedLeaderboard("summary");
    }
  }, []);

  useEffect(() => {
    if (selectedLeaderboard) {
      localStorage.setItem("cx-selected-leaderboard", selectedLeaderboard);
    }
  }, [selectedLeaderboard]);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    const leaderboardExpanded = localStorage.getItem("cx-leaderboard-expanded");
    const queueLeaderboardExpanded = localStorage.getItem(
      "cx-queue-leaderboard-expanded"
    );
    const expandedQueues = localStorage.getItem("cx-expanded-queue-widgets");
    const toggledQueues = localStorage.getItem("cx-toggled-queues");
    const getDisplayPortraits = localStorage.getItem("cx-display-portraits");
    if (!getDisplayPortraits) {
      setDisplayPortraits(true);
      localStorage.setItem("cx-display-portraits", JSON.stringify(true));
    }
    if (getDisplayPortraits) {
      setDisplayPortraits(JSON.parse(getDisplayPortraits));
    }
    if (!leaderboardExpanded) {
      setExpandedCxAgentLeaderboard(true);
      localStorage.setItem("cx-leaderboard-expanded", JSON.stringify(true));
    }
    if (leaderboardExpanded) {
      setExpandedCxAgentLeaderboard(JSON.parse(leaderboardExpanded));
    }
    if (!queueLeaderboardExpanded) {
      setExpandedCxQueueLeaderboard(true);
      localStorage.setItem(
        "cx-queue-leaderboard-expanded",
        JSON.stringify(true)
      );
    }
    if (queueLeaderboardExpanded) {
      setExpandedCxQueueLeaderboard(JSON.parse(queueLeaderboardExpanded));
    }
    if (!expandedQueues) {
      setExpandQueues(true);
      localStorage.setItem("cx-expanded-queue-widgets", JSON.stringify(true));
    }
    if (expandedQueues) {
      setExpandQueues(JSON.parse(expandedQueues));
    }
  }, []);

  useEffect(() => {
    if (mode === "light") {
      setColorWeight(600);
      setBackgroundWeight(100);
      setColor("initial");
      setBorderColors({ green: "green", red: "red", grey: "grey" });
      return;
    }

    setColorWeight(300);
    setBackgroundWeight(1000);
    setColor("white");
    setBorderColors({
      green: "lightgreen",
      red: "lightcoral",
      grey: "lightgrey",
    });
  }, [mode]);

  const smaller = useCallback(() => {
    setHeight((prev) => (prev < 20 ? prev : prev - 10));
  }, []);

  const larger = useCallback(() => {
    setHeight((prev) => (prev > 80 ? prev : prev + 10));
  }, []);

  const increaseFont = useCallback(() => {
    if (fontSize === "small") {
      setFontSize("medium");
    } else if (fontSize === "medium") {
      setFontSize("large");
    }
  }, [fontSize]);

  const decreaseFont = useCallback(() => {
    if (fontSize === "large") {
      setFontSize("medium");
    } else if (fontSize === "medium") {
      setFontSize("small");
    }
  }, [fontSize]);

  useEffect(() => {
    if (agentsLoaded) {
      return;
    }
    // get all historical cx data
    const fetchData = async () => {
      const data = (await fetch(
        forwardAddress.replace("/shadow-agent", "/ringcx-data"),
        {
          method: "get",
          headers: {
            Authorization: idToken,
          },
        }
      ).then((res) => res.json())) as {
        agents: Array<CXAgent>;
        queues: Array<CXQueue>;
        agentGroups: Array<{
          agentGroupId: number;
          groupName: string;
          agents: Array<number>;
        }>;
        queueGroups: Array<{
          gateGroupId: number;
          groupName: string;
          agents: Array<number>;
          queues: Array<number>;
        }>;
        supervisors: Array<{
          supervisorId: number;
          agents: Array<number>;
          firstName?: string;
          lastName?: string;
        }>;
      };

      //   console.log("DATA", data);
      setCxAgents(
        data.agents.map((a) => ({
          id: a.agentId.toString(),
          agentId: a.agentId,
          groupId: a.groupId,
          groupName: a.groupName,
          firstName: a.firstName,
          lastName: a.lastName,
          agentType: a.agentType,
          stateTimestamp: a.stateTimestamp,
          agentState: a.agentState,
          queues: a.queues,
          rcUserId: a.rcUserId,
          supervisees: a.supervisees,
          supervisors: a.supervisors,
        }))
      );

      setMe(data.agents.find((agent) => agent.rcUserId === rcId));

      setQueues(
        data.queues.map((q) => ({
          id: q.gateId.toString(),
          gateGroupId: q.gateGroupId,
          gateGroupName: q.gateGroupName,
          groupName: q.groupName,
          gateId: q.gateId,
          gateName: q.gateName,
          gateDesc: q.gateDesc,
          assignedAgents: q.assignedAgents,
        }))
      );

      setAgentGroups(
        data.agentGroups.map((ag) => ({
          id: ag.agentGroupId.toString(),
          agentGroupId: ag.agentGroupId,
          groupName: ag.groupName,
          agents: ag.agents,
        }))
      );
      setQueueGroups(
        data.queueGroups.map((qg) => ({
          id: qg.gateGroupId.toString(),
          gateGroupId: qg.gateGroupId,
          groupName: qg.groupName,
          queues: qg.queues,
          agents: qg.agents,
        }))
      );

      setSupervisors(
        data.supervisors.map((sup) => ({
          id: sup.supervisorId.toString(),
          supervisorId: sup.supervisorId,
          agents: sup.agents,
          firstName: sup.firstName,
          lastName: sup.lastName,
        }))
      );
    };

    (async () => {
      await fetchData();
    })();
  }, [idToken, forwardAddress, agentsLoaded]);

  useEffect(() => {
    if (agentsLoaded) return;
    if (cxAgents === undefined) return;
    setAgentsLoaded(true);
  }, [cxAgents, agentsLoaded]);

  useEffect(() => {
    if (!agentsLoaded) {
      return;
    }
    if (historicalUsers.length === 0) {
      return;
    }

    setCxAgents((oldCxAgents) =>
      oldCxAgents?.map((agent) => {
        const myUser = historicalUsers.find(
          (user: any) => agent.rcUserId && user.id === agent.rcUserId
        );

        const display =
          agent.messageTimestamp &&
          myUser?.messageTimestamp &&
          myUser?.messageTimestamp < agent.messageTimestamp
            ? agent.display
            : myUser?.display;
        const messageTimestamp =
          agent.messageTimestamp &&
          myUser?.messageTimestamp &&
          myUser?.messageTimestamp < agent.messageTimestamp
            ? agent.messageTimestamp
            : myUser?.messageTimestamp;

        return {
          ...agent,
          department: myUser?.department,
          site: myUser?.site?.name,
          portrait: myUser?.signedUrl || "./default-user-image.ico",
          global: myUser?.status,
          display,
          messageTimestamp,
        };
      })
    );
    // if (departments !== undefined) {
    //     return;
    // }

    setDepartments(() =>
      Array.from(
        historicalUsers.reduce((sum: any, user: any) => {
          sum.add(user.department);
          return sum;
        }, new Set())
      ).map(
        (name) =>
          ({
            id: name,
            name,
          } as CXDepartment)
      )
    );
    setSites(() =>
      Array.from(
        historicalUsers.reduce((sum: any, user: any) => {
          if (user.site) {
            sum.add(user.site.name);
          }

          return sum;
        }, new Set())
      ).map(
        (name) =>
          ({
            id: name,
            name,
          } as CXSite)
      )
    );
  }, [historicalUsers, agentsLoaded]);

  useEffect(() => {
    setProcessingExPresence(presenceEvents[0]);
  }, [presenceEvents]);

  useEffect(() => {
    const item = processingExPresence;

    if (item === undefined || !agentsLoaded) {
      return;
    }

    setCxAgents((oldAgents) =>
      oldAgents?.map((agent) => {
        if (agent.rcUserId === undefined) return agent;
        if (
          agent.rcUserId.toString() === item.id.toString() &&
          (agent.messageTimestamp === undefined ||
            new Date(agent.messageTimestamp).getTime() <
              new Date(item.messageTimestamp).getTime())
        ) {
          return {
            ...agent,
            messageTimestamp: item.messageTimestamp,
            display: item.display,
          };
        }
        return agent;
      })
    );
  }, [presenceEvents, agentsLoaded]);

  // ringCX websocket
  useEffect(() => {
    let isMounted = true;
    let cb: any;
    let temp: WebSocket | undefined;
    let retryCount = 0;

    if (!cxError) {
      const connect = () => {
        clearTimeout(cb);

        cb = setTimeout(connect, 90 * 60 * 1000); // refresh socket every 90 min
        temp = new WebSocket(`${cxWebsocketAdress}/?authorization=${idToken}`);

        temp.onopen = () => {
          if (!isMounted) return;

          retryCount = 0;
          setCxRetries(0);

          setCxWs((oldWS) => {
            if (!oldWS) {
              temp?.send(JSON.stringify({ action: "" }));
            }
            return temp;
          });
        };

        temp.onerror = (err) => {
          console.error("WebSocket error:", err);
          clearTimeout(cb);
          if (isMounted) {
            setCxError(true);
          }
        };

        temp.onclose = () => {
          console.warn("WebSocket closed, attempting reconnect...");
          clearTimeout(cb);
          if (!isMounted) return;

          if (retryCount < MAX_RETRY) {
            retryCount += 1;
            cb = setTimeout(connect, 3000);
            setCxRetries(retryCount);
          } else {
            setTimeout(() => {
              if (isMounted) {
                setCxError(true);
              }
            }, 0);
          }
        };
      };

      isMounted = true;
      connect();
    }

    return () => {
      isMounted = false;
      clearTimeout(cb);
      temp?.close();
    };
  }, [idToken, cxError]);

  useEffect(() => {
    const attempt = async (
      fn: (arg: string | undefined) => Promise<any>,
      arg: string | undefined,
      delayMs: number
    ) => {
      try {
        await fn(arg);
      } catch (err) {
        if (delayMs > 320 * 1000) {
          console.log("Error loading data", err);
          return;
        }
        await new Promise((resolve) => setTimeout(resolve, delayMs));
        await attempt(fn, arg, delayMs * 2);
      }
    };

    // console.log("get cx data", extensions);

    const getCxData = async () => {
      const todayStart = new Date();
      todayStart.setHours(0, 0, 0, 0);
      todayStart.setHours(todayStart.getHours() + offset);
      const startTime = todayStart.toISOString();
      console.log("start time", startTime, offset);

      const api: string = `${forwardAddress.replace(
        "/shadow-agent",
        "/ringcx-deltas"
      )}?startTime=${startTime}`;
      //   let api: string;
      // api always requires startTime
      //   if (next) {
      //     api = next;
      //   } else {
      //     api = ;
      //   }

      const messages: Array<CXExtension> = [];

      try {
        const res: any = await fetch(api, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${idToken}`,
            "Content-Type": "application/json",
          },
        });

        const resp: {
          extensions: Array<CXExtension>;
          activeCalls: Array<CXExtension & { ended?: boolean; id: string }>;
          waitingCalls: Array<CXExtension & { ended?: boolean; id: string }>;
        } = await res.json();

        // console.log("CX RES", resp);
        resp.extensions.forEach((extension) => {
          setExtensions((oldExtensions) => {
            if (
              oldExtensions?.find(
                (temp) => temp.extensionId === extension.extensionId
              )
            ) {
              return oldExtensions.map((temp) => {
                if (temp.extensionId === extension.extensionId) {
                  return cols.reduce((sum, col) => {
                    if (col === "extensionId") {
                      return {
                        ...sum,
                        extensionId: extension.extensionId,
                      };
                    }

                    if (col === "extension") {
                      return {
                        ...sum,
                        extension: extension.extension,
                      };
                    }

                    if (col === "state") {
                      let state;
                      let timestamp;

                      if (extension.timestamp === undefined) {
                        state = temp.state;
                        timestamp = temp.timestamp;
                      } else if (
                        temp.timestamp === undefined ||
                        extension.timestamp > temp.timestamp
                      ) {
                        timestamp = extension.timestamp;
                        state = extension.state;
                      } else {
                        timestamp = temp.timestamp;
                        state = temp.state;
                      }

                      const myActivePhoneNumbers = temp.activePhoneNumbers
                        ? new Map(temp.activePhoneNumbers)
                        : new Map();
                      //   const myQueues = new Set(
                      //     (temp.queues || []).concat(extension.queues || [])
                      //   );

                      const myRingingPhoneNumbers = temp.ringingPhoneNumbers
                        ? new Map(temp.ringingPhoneNumbers)
                        : new Map();

                      //   if (state === "IDLE") {
                      //     extension.queues?.forEach((queue) => {
                      //       myQueues.delete(queue);
                      //     });
                      //     // myActivePhoneNumbers.clear(); // ?
                      //   }

                      const activeCount =
                        (extension.activeCount || 0) + (temp.activeCount || 0);
                      const waitingCount =
                        (extension.waitingCount || 0) +
                        (temp.waitingCount || 0);
                      if (activeCount === 0) {
                        myActivePhoneNumbers.clear();
                        if (waitingCount === 0) {
                          myRingingPhoneNumbers.clear();
                          state = "IDLE";
                        } else {
                          state = `${waitingCount} WAITING`;
                          if (extension.waitingCount === 1) {
                            if (!myRingingPhoneNumbers.has(extension.ani)) {
                              myRingingPhoneNumbers.set(extension.ani, {
                                phoneNumber: extension.ani,
                                timestamp: extension.timestamp,
                              });
                            }
                          } else if (extension.waitingCount === -1) {
                            if (myRingingPhoneNumbers.has(extension.ani)) {
                              myRingingPhoneNumbers.delete(extension.ani);
                            }
                          }
                        }
                      } else if (waitingCount === 0) {
                        myRingingPhoneNumbers.clear();
                        if (extension.activeCount === 1) {
                          if (!myActivePhoneNumbers.has(extension.ani)) {
                            myActivePhoneNumbers.set(extension.ani, {
                              phoneNumber: extension.ani,
                              timestamp: extension.timestamp,
                            });
                          }
                        } else if (extension.activeCount === -1) {
                          if (myActivePhoneNumbers.has(extension.ani)) {
                            myActivePhoneNumbers.delete(extension.ani);
                          }
                        }
                        state = `${activeCount} ACTIVE`;
                        // if (extension.extension === "queue") {
                        //   state = `${activeCount} ACTIVE`;
                        // } else {
                        //   state = Array.from(myQueues)
                        //     .map((queue) => `ON QUEUE CALL: ${queue}`)
                        //     .join("\n");
                        // }
                      } else {
                        state = `${activeCount} ACTIVE\n${waitingCount} WAITING`;
                        if (extension.activeCount === 1) {
                          if (!myActivePhoneNumbers.has(extension.ani)) {
                            myActivePhoneNumbers.set(extension.ani, {
                              phoneNumber: extension.ani,
                              timestamp: extension.timestamp,
                            });
                          }
                        } else if (extension.activeCount === -1) {
                          if (myActivePhoneNumbers.has(extension.ani)) {
                            myActivePhoneNumbers.delete(extension.ani);
                          }
                        }
                        if (extension.waitingCount === 1) {
                          if (!myRingingPhoneNumbers.has(extension.ani)) {
                            myRingingPhoneNumbers.set(extension.ani, {
                              phoneNumber: extension.ani,
                              timestamp: extension.timestamp,
                            });
                          }
                        } else if (extension.waitingCount === -1) {
                          if (myRingingPhoneNumbers.has(extension.ani)) {
                            myRingingPhoneNumbers.delete(extension.ani);
                          }
                        }
                      }

                      return {
                        ...sum,
                        state,
                        timestamp,
                        // queues: Array.from(myQueues),
                        activePhoneNumbers: myActivePhoneNumbers,
                        ringingPhoneNumbers: myRingingPhoneNumbers,
                      };
                    }

                    if (
                      extension[col] === undefined &&
                      temp[col] === undefined
                    ) {
                      return sum;
                    }

                    if (temp[col] === undefined) {
                      return {
                        ...sum,
                        [col]: extension[col],
                      };
                    }

                    if (extension[col] === undefined) {
                      return {
                        ...sum,
                        [col]: temp[col],
                      };
                    }

                    return {
                      ...sum,
                      [col]: (extension[col] as number) + (temp[col] as number),
                    };
                  }, {}) as CXExtension;
                }

                return temp;
              });
            }

            const myActivePhoneNumbers = new Map();
            const myRingingPhoneNumbers = new Map();
            let { state } = extension;
            const activeCount = extension.activeCount || 0;
            const waitingCount = extension.waitingCount || 0;
            if (activeCount === 0) {
              // myActivePhoneNumbers.clear();
              if (waitingCount === 0) {
                // myRingingPhoneNumbers.clear();
                state = "IDLE";
              } else {
                state = `${waitingCount} WAITING`;
                if (waitingCount === 1) {
                  myRingingPhoneNumbers.set(extension.ani, {
                    phoneNumber: extension.ani,
                    timestamp: extension.timestamp,
                  });
                }
              }
            } else if (waitingCount === 0) {
              // myRingingPhoneNumbers.clear();
              if (activeCount === 1) {
                myActivePhoneNumbers.set(extension.ani, {
                  phoneNumber: extension.ani,
                  timestamp: extension.timestamp,
                });
              }
              state = `${activeCount} ACTIVE`;
            } else {
              state = `${activeCount} ACTIVE\n${waitingCount} WAITING`;
              if (activeCount === 1) {
                myActivePhoneNumbers.set(extension.ani, {
                  phoneNumber: extension.ani,
                  timestamp: extension.timestamp,
                });
              }
              if (waitingCount === 1) {
                myRingingPhoneNumbers.set(extension.ani, {
                  phoneNumber: extension.ani,
                  timestamp: extension.timestamp,
                });
              }
            }

            return (oldExtensions || []).concat([
              {
                ...extension,
                state,
                activePhoneNumbers: myActivePhoneNumbers,
                ringingPhoneNumbers: myRingingPhoneNumbers,
              },
            ]);
          });
        });

        setActiveCalls((oldActiveCalls) => {
          const myActiveCalls = new Map(oldActiveCalls);
          resp.activeCalls.forEach((ext) => {
            if (ext.extension === "agent" && ext.activeCount === 1) {
              const queueCall = myActiveCalls.get(
                `${ext.queues?.[0]}-${ext.callId}`
              );
              if (queueCall) {
                if (
                  !queueCall.ended &&
                  queueCall.activeAgent !== ext.extensionId &&
                  ext.timestamp &&
                  queueCall.timestamp &&
                  ext.timestamp > queueCall.timestamp
                ) {
                  queueCall.activeAgent = ext.extensionId;
                  queueCall.timestamp = ext.timestamp;
                  myActiveCalls.set(
                    `${ext.queues?.[0]}-${ext.callId}`,
                    queueCall
                  );
                }
              } else {
                myActiveCalls.set(`${ext.queues?.[0]}-${ext.callId}`, {
                  callId: ext.callId,
                  timestamp: ext.timestamp,
                  extensionId: ext.queues?.[0] || "",
                  ani: ext.ani,
                  dnis: ext.dnis,
                  callStart: ext.callStart,
                  extension: ext.extension,
                  duration: ext.duration,
                  activeAgent: ext.extensionId,
                  direction: ext.direction,
                });
              }
            }
            if (ext.extension === "queue" && ext.activeCount === 1) {
              const queueCall = myActiveCalls.get(
                `${ext.extensionId}-${ext.callId}`
              );
              if (queueCall) {
                if (queueCall.ended) {
                  myActiveCalls.delete(`${ext.extensionId}-${ext.callId}`);
                } else {
                  myActiveCalls.set(`${ext.extensionId}-${ext.callId}`, {
                    callId: ext.callId,
                    timestamp:
                      ext.timestamp &&
                      queueCall.timestamp &&
                      ext.timestamp > queueCall.timestamp
                        ? ext.timestamp
                        : queueCall.timestamp,
                    extensionId: ext.extensionId,
                    ani: ext.ani,
                    dnis: ext.dnis,
                    callStart: ext.callStart,
                    extension: ext.extension,
                    duration: ext.duration,
                    activeAgent:
                      !queueCall.activeAgent ||
                      (ext.timestamp &&
                        queueCall.timestamp &&
                        ext.timestamp > queueCall.timestamp)
                        ? ext.activeAgent
                        : queueCall.activeAgent,
                    direction: ext.direction,
                  });
                }
              } else {
                myActiveCalls.set(`${ext.extensionId}-${ext.callId}`, {
                  callId: ext.callId,
                  timestamp: ext.timestamp,
                  extensionId: ext.extensionId,
                  ani: ext.ani,
                  dnis: ext.dnis,
                  callStart: ext.callStart,
                  extension: ext.extension,
                  duration: ext.duration,
                  activeAgent: ext.activeAgent,
                  direction: ext.direction,
                });
              }
            }
            if (ext.extension === "queue" && ext.activeCount === -1) {
              const queueCall = myActiveCalls.get(
                `${ext.extensionId}-${ext.callId}`
              );
              if (queueCall) {
                myActiveCalls.delete(`${ext.extensionId}-${ext.callId}`);
              } else {
                myActiveCalls.set(`${ext.extensionId}-${ext.callId}`, {
                  ended: true,
                  duration: 0,
                  extensionId: ext.extensionId,
                  callId: ext.callId,
                  ani: ext.ani,
                  dnis: ext.dnis,
                  extension: ext.extension,
                  callStart: ext.callStart,
                  direction: ext.direction,
                });
              }
            }
          });

          return myActiveCalls;
        });

        setWaitingCalls((oldWaitingCalls) => {
          const myWaitingCalls = new Map(oldWaitingCalls);
          resp.waitingCalls.forEach((ext) => {
            if (ext.extension === "queue" && ext.waitingCount === 1) {
              const myCall = myWaitingCalls.get(
                `${ext.extensionId}-${ext.callId}`
              );
              if (myCall && myCall.ended) {
                myWaitingCalls.delete(`${ext.extensionId}-${ext.callId}`);
              } else {
                myWaitingCalls.set(`${ext.extensionId}-${ext.callId}`, {
                  callId: ext.callId,
                  timestamp: ext.timestamp,
                  extensionId: ext.extensionId,
                  ani: ext.ani,
                  dnis: ext.dnis,
                  callStart: ext.callStart,
                  extension: ext.extension,
                  duration: ext.duration,
                  direction: ext.direction,
                });
              }
            }

            if (ext.extension === "queue" && ext.waitingCount === -1) {
              if (myWaitingCalls.has(`${ext.extensionId}-${ext.callId}`)) {
                myWaitingCalls.delete(`${ext.extensionId}-${ext.callId}`);
              } else {
                myWaitingCalls.set(`${ext.extensionId}-${ext.callId}`, {
                  ended: true,
                  duration: 0,
                  extensionId: ext.extensionId,
                  callId: ext.callId,
                  ani: ext.ani,
                  dnis: ext.dnis,
                  extension: ext.extension,
                  callStart: ext.callStart,
                  direction: ext.direction,
                });
              }
            }
          });
          return myWaitingCalls;
        });
      } catch (err) {
        console.log(err);
      }

      //   const lines: Array<CXExtension> = resp.messages;
      //   console.log("cx call API", messages);

      messages.forEach((extension) => {
        setLongestWaiting((oldLongestWaiting) => {
          const activeEvents = oldLongestWaiting;
          if (
            extension.extension === "queue" &&
            extension.state === "WAITING"
          ) {
            activeEvents.set(extension.callId, {
              callId: extension.callId,
              timestamp: extension.timestamp,
              extensionId: extension.extensionId,
            });
          }
          if (
            extension.extension === "queue" &&
            extension.state !== "WAITING"
          ) {
            const isPreviousEntry = activeEvents.get(extension.callId);
            if (isPreviousEntry) {
              activeEvents.delete(isPreviousEntry.callId);
            }
          }
          return activeEvents;
        });
        //   const cxCallsInPogressCopy = new Map(cxCallsInProgress);
      });

      //   if (resp.next !== undefined) {
      //     attempt(getCxData, resp.next, 10 * 1000);
      //   }
    };

    (async () => {
      //   await attempt(getCxData, undefined, 10 * 1000);
      await getCxData();
      //   console.log("cx done");
    })();
  }, [forwardAddress, idToken]);

  const cxWsListener = useCallback((event: any) => {
    const data = JSON.parse(event.data) as
      | CXAgentState
      | CXQueueState
      | { topic: string; messages: Array<CXExtension> }
      | Event;
    // console.log("data", data);
    if ("pong" in data) {
      // ping();
    } else if ("event" in data) {
      // nothing
    } else if ("topic" in data) {
      //   console.log("data", data);
      const myData = data as
        | CXQueueState
        | CXAgentState
        | { topic: string; messages: Array<CXExtension> };
      const activeEvents = longestWaiting;
      if (myData.topic === "agent-state") {
        if (
          (myData as CXAgentState).agentState !== undefined &&
          (myData as CXAgentState).agentId !== undefined
        ) {
          if (
            me &&
            (myData as CXAgentState).agentId.toString() ===
              me?.agentId.toString() &&
            (myData as CXAgentState).agentState !== me.agentState
          ) {
            getCxCalls();
          }
        }
        const presence = myData as CXAgentState;
        setCxStateEvents((cxStates) =>
          cxStates.concat([
            {
              agentId: presence.agentId,
              dateTime: presence.dateTime,
              agentState: presence.agentState,
              previousState: presence.previousState,
              topic: presence.topic,
            },
          ])
        );
      } else if (myData.topic === "queue-presence") {
        const queueUpdate = myData as CXQueueState;
        setCxQueueStateEvents((cxQueueStates) =>
          cxQueueStates.concat([
            {
              agentId: queueUpdate.agentId,
              dateTime: queueUpdate.dateTime,
              update: queueUpdate.update,
              topic: queueUpdate.topic,
            },
          ])
        );
      } else if (myData.topic === "leaderboard-deltas") {
        const list = myData as { topic: string; messages: Array<CXExtension> };
        console.log("list", list);
        setCxMessages((oldCxMessages) => oldCxMessages.concat([list.messages]));
        list.messages.forEach((extension) => {
          setActiveCalls((oldActiveCalls) => {
            const myActiveCalls = new Map(oldActiveCalls);
            if (
              extension.extension === "agent" &&
              extension.activeCount === 1
            ) {
              const queueCall = myActiveCalls.get(
                `${extension.queues?.[0]}-${extension.callId}`
              );
              if (queueCall) {
                if (
                  !queueCall.ended &&
                  queueCall.activeAgent !== extension.extensionId &&
                  extension.timestamp &&
                  queueCall.timestamp &&
                  extension.timestamp > queueCall.timestamp
                ) {
                  queueCall.activeAgent = extension.extensionId;
                  queueCall.timestamp = extension.timestamp;
                  myActiveCalls.set(
                    `${extension.queues?.[0]}-${extension.callId}`,
                    queueCall
                  );
                }
              } else {
                myActiveCalls.set(
                  `${extension.queues?.[0]}-${extension.callId}`,
                  {
                    callId: extension.callId,
                    timestamp: extension.timestamp,
                    extensionId: extension.queues?.[0] || "",
                    ani: extension.ani,
                    dnis: extension.dnis,
                    callStart: extension.callStart,
                    extension: extension.extension,
                    duration: extension.duration,
                    activeAgent: extension.extensionId,
                    direction: extension.direction,
                  }
                );
              }
            }
            if (
              extension.extension === "queue" &&
              extension.activeCount === 1
            ) {
              const queueCall = myActiveCalls.get(
                `${extension.extensionId}-${extension.callId}`
              );
              if (queueCall) {
                if (queueCall.ended) {
                  myActiveCalls.delete(
                    `${extension.extensionId}-${extension.callId}`
                  );
                } else {
                  myActiveCalls.set(
                    `${extension.extensionId}-${extension.callId}`,
                    {
                      callId: extension.callId,
                      timestamp:
                        extension.timestamp &&
                        queueCall.timestamp &&
                        extension.timestamp > queueCall.timestamp
                          ? extension.timestamp
                          : queueCall.timestamp,
                      extensionId: extension.extensionId,
                      ani: extension.ani,
                      dnis: extension.dnis,
                      callStart: extension.callStart,
                      extension: extension.extension,
                      duration: extension.duration,
                      activeAgent:
                        !queueCall.activeAgent ||
                        (extension.timestamp &&
                          queueCall.timestamp &&
                          extension.timestamp > queueCall.timestamp)
                          ? extension.activeAgent
                          : queueCall.activeAgent,
                      direction: extension.direction,
                    }
                  );
                }
              } else {
                myActiveCalls.set(
                  `${extension.extensionId}-${extension.callId}`,
                  {
                    callId: extension.callId,
                    timestamp: extension.timestamp,
                    extensionId: extension.extensionId,
                    ani: extension.ani,
                    dnis: extension.dnis,
                    callStart: extension.callStart,
                    extension: extension.extension,
                    duration: extension.duration,
                    activeAgent: extension.activeAgent,
                    direction: extension.direction,
                  }
                );
              }
            }
            if (
              extension.extension === "queue" &&
              extension.activeCount === -1
            ) {
              if (
                myActiveCalls.has(
                  `${extension.extensionId}-${extension.callId}`
                )
              ) {
                myActiveCalls.delete(
                  `${extension.extensionId}-${extension.callId}`
                );
              } else {
                myActiveCalls.set(
                  `${extension.extensionId}-${extension.callId}`,
                  {
                    ended: true,
                    duration: 0,
                    extensionId: extension.extensionId,
                    callId: extension.callId,
                    ani: extension.ani,
                    dnis: extension.dnis,
                    extension: extension.extension,
                    callStart: extension.callStart,
                    direction: extension.direction,
                  }
                );
              }
            }

            return myActiveCalls;
          });

          setWaitingCalls((oldWaitingCalls) => {
            const myWaitingCalls = new Map(oldWaitingCalls);
            if (
              extension.extension === "queue" &&
              extension.waitingCount === 1
            ) {
              const myCall = myWaitingCalls.get(
                `${extension.extensionId}-${extension.callId}`
              );

              if (myCall && myCall.ended) {
                myWaitingCalls.delete(
                  `${extension.extensionId}-${extension.callId}`
                );
              } else {
                myWaitingCalls.set(
                  `${extension.extensionId}-${extension.callId}`,
                  {
                    callId: extension.callId,
                    timestamp: extension.timestamp,
                    extensionId: extension.extensionId,
                    ani: extension.ani,
                    dnis: extension.dnis,
                    callStart: extension.callStart,
                    extension: extension.extension,
                    duration: extension.duration,
                    direction: extension.direction,
                  }
                );
              }
            }

            if (
              extension.extension === "queue" &&
              extension.waitingCount === -1
            ) {
              if (
                myWaitingCalls.has(
                  `${extension.extensionId}-${extension.callId}`
                )
              ) {
                myWaitingCalls.delete(
                  `${extension.extensionId}-${extension.callId}`
                );
              } else {
                myWaitingCalls.set(
                  `${extension.extensionId}-${extension.callId}`,
                  {
                    ended: true,
                    duration: 0,
                    extensionId: extension.extensionId,
                    callId: extension.callId,
                    ani: extension.ani,
                    dnis: extension.dnis,
                    extension: extension.extension,
                    callStart: extension.callStart,
                    direction: extension.direction,
                  }
                );
              }
            }

            return myWaitingCalls;
          });

          if (
            extension.extension === "queue" &&
            extension.state === "WAITING"
          ) {
            activeEvents.set(extension.callId, {
              callId: extension.callId,
              timestamp: extension.timestamp,
              extensionId: extension.extensionId,
            });
          }
          if (
            extension.extension === "queue" &&
            extension.state !== "WAITING"
          ) {
            const isPreviousEntry = activeEvents.get(extension.callId);
            if (isPreviousEntry) {
              activeEvents.delete(isPreviousEntry.callId);
            }
          }
          setLongestWaiting(activeEvents);
          //   const cxCallsInPogressCopy = new Map(cxCallsInProgress);
          setExtensions((oldExtensions) => {
            if (
              oldExtensions?.find(
                (temp) => temp.extensionId === extension.extensionId
              )
            ) {
              return oldExtensions.map((temp) => {
                if (temp.extensionId === extension.extensionId) {
                  return cols.reduce((sum, col) => {
                    if (col === "extensionId") {
                      return {
                        ...sum,
                        extensionId: extension.extensionId,
                      };
                    }

                    if (col === "extension") {
                      return {
                        ...sum,
                        extension: extension.extension,
                      };
                    }

                    if (col === "state") {
                      let state;
                      let timestamp;

                      if (extension.timestamp === undefined) {
                        state = temp.state;
                        timestamp = temp.timestamp;
                      } else if (
                        temp.timestamp === undefined ||
                        extension.timestamp > temp.timestamp
                      ) {
                        timestamp = extension.timestamp;
                        state = extension.state;
                      } else {
                        timestamp = temp.timestamp;
                        state = temp.state;
                      }

                      const myActivePhoneNumbers = temp.activePhoneNumbers
                        ? new Map(temp.activePhoneNumbers)
                        : new Map();
                      //   const myQueues = new Set(
                      //     (temp.queues || []).concat(extension.queues || [])
                      //   );

                      const myRingingPhoneNumbers = temp.ringingPhoneNumbers
                        ? new Map(temp.ringingPhoneNumbers)
                        : new Map();

                      //   if (state === "IDLE") {
                      //     extension.queues?.forEach((queue) => {
                      //       myQueues.delete(queue);
                      //     });
                      //     // myActivePhoneNumbers.clear(); // ?
                      //   }

                      const activeCount =
                        (extension.activeCount || 0) + (temp.activeCount || 0);
                      const waitingCount =
                        (extension.waitingCount || 0) +
                        (temp.waitingCount || 0);
                      if (activeCount === 0) {
                        myActivePhoneNumbers.clear();
                        if (waitingCount === 0) {
                          myRingingPhoneNumbers.clear();
                          state = "IDLE";
                        } else {
                          state = `${waitingCount} WAITING`;
                          if (extension.waitingCount === 1) {
                            if (!myRingingPhoneNumbers.has(extension.ani)) {
                              myRingingPhoneNumbers.set(extension.ani, {
                                phoneNumber: extension.ani,
                                timestamp: extension.timestamp,
                              });
                            }
                          } else if (extension.waitingCount === -1) {
                            if (myRingingPhoneNumbers.has(extension.ani)) {
                              myRingingPhoneNumbers.delete(extension.ani);
                            }
                          }
                        }
                      } else if (waitingCount === 0) {
                        myRingingPhoneNumbers.clear();
                        if (extension.activeCount === 1) {
                          if (!myActivePhoneNumbers.has(extension.ani)) {
                            myActivePhoneNumbers.set(extension.ani, {
                              phoneNumber: extension.ani,
                              timestamp: extension.timestamp,
                            });
                          }
                        } else if (extension.activeCount === -1) {
                          if (myActivePhoneNumbers.has(extension.ani)) {
                            myActivePhoneNumbers.delete(extension.ani);
                          }
                        }
                        state = `${activeCount} ACTIVE`;
                        // if (extension.extension === "queue") {
                        //   state = `${activeCount} ACTIVE`;
                        // } else {
                        //   state = Array.from(myQueues)
                        //     .map((queue) => `ON QUEUE CALL: ${queue}`)
                        //     .join("\n");
                        // }
                      } else {
                        state = `${activeCount} ACTIVE\n${waitingCount} WAITING`;
                        if (extension.activeCount === 1) {
                          if (!myActivePhoneNumbers.has(extension.ani)) {
                            myActivePhoneNumbers.set(extension.ani, {
                              phoneNumber: extension.ani,
                              timestamp: extension.timestamp,
                            });
                          }
                        } else if (extension.activeCount === -1) {
                          if (myActivePhoneNumbers.has(extension.ani)) {
                            myActivePhoneNumbers.delete(extension.ani);
                          }
                        }
                        if (extension.waitingCount === 1) {
                          if (!myRingingPhoneNumbers.has(extension.ani)) {
                            myRingingPhoneNumbers.set(extension.ani, {
                              phoneNumber: extension.ani,
                              timestamp: extension.timestamp,
                            });
                          }
                        } else if (extension.waitingCount === -1) {
                          if (myRingingPhoneNumbers.has(extension.ani)) {
                            myRingingPhoneNumbers.delete(extension.ani);
                          }
                        }
                      }

                      return {
                        ...sum,
                        state,
                        timestamp,
                        // queues: Array.from(myQueues),
                        activePhoneNumbers: myActivePhoneNumbers,
                        ringingPhoneNumbers: myRingingPhoneNumbers,
                      };
                    }

                    if (
                      extension[col] === undefined &&
                      temp[col] === undefined
                    ) {
                      return sum;
                    }

                    if (temp[col] === undefined) {
                      return {
                        ...sum,
                        [col]: extension[col],
                      };
                    }

                    if (extension[col] === undefined) {
                      return {
                        ...sum,
                        [col]: temp[col],
                      };
                    }

                    return {
                      ...sum,
                      [col]: (extension[col] as number) + (temp[col] as number),
                    };
                  }, {}) as CXExtension;
                }

                return temp;
              });
            }

            const myActivePhoneNumbers = new Map();
            const myRingingPhoneNumbers = new Map();
            let { state } = extension;
            const activeCount = extension.activeCount || 0;
            const waitingCount = extension.waitingCount || 0;
            if (activeCount === 0) {
              // myActivePhoneNumbers.clear();
              if (waitingCount === 0) {
                // myRingingPhoneNumbers.clear();
                state = "IDLE";
              } else {
                state = `${waitingCount} WAITING`;
                if (waitingCount === 1) {
                  myRingingPhoneNumbers.set(extension.ani, {
                    phoneNumber: extension.ani,
                    timestamp: extension.timestamp,
                  });
                }
              }
            } else if (waitingCount === 0) {
              // myRingingPhoneNumbers.clear();
              if (activeCount === 1) {
                myActivePhoneNumbers.set(extension.ani, {
                  phoneNumber: extension.ani,
                  timestamp: extension.timestamp,
                });
              }
              state = `${activeCount} ACTIVE`;
            } else {
              state = `${activeCount} ACTIVE\n${waitingCount} WAITING`;
              if (activeCount === 1) {
                myActivePhoneNumbers.set(extension.ani, {
                  phoneNumber: extension.ani,
                  timestamp: extension.timestamp,
                });
              }
              if (waitingCount === 1) {
                myRingingPhoneNumbers.set(extension.ani, {
                  phoneNumber: extension.ani,
                  timestamp: extension.timestamp,
                });
              }
            }

            return (oldExtensions || []).concat([
              {
                ...extension,
                state,
                activePhoneNumbers: myActivePhoneNumbers,
                ringingPhoneNumbers: myRingingPhoneNumbers,
              },
            ]);
          });
        });
      }
    }
  }, []);

  useEffect(() => {
    if (cxWs === undefined) {
      return;
    }

    cxWs.addEventListener("message", cxWsListener);

    // eslint-disable-next-line consistent-return
    return () => {
      cxWs.removeEventListener("message", cxWsListener);
    };
  }, [cxWs, cxWsListener]);

  useEffect(() => {
    if (cxWs === undefined) {
      return;
    }

    let callback: any;

    const ping = () => {
      callback = setTimeout(() => {
        // console.log("ping");
        cxWs.send(JSON.stringify({ action: "ping" }));

        ping();
      }, 30 * 1000);
    };

    ping();

    // eslint-disable-next-line consistent-return
    return () => {
      clearTimeout(callback);
    };
  }, [cxWs]);

  useEffect(() => {
    if (!agentsLoaded) return;
    if (cxStateEvents.length) {
      setCxStateEvents((events) => events.slice(1));
    }
  }, [cxStateEvents, agentsLoaded]);

  useEffect(() => {
    if (!agentsLoaded) return;
    if (cxQueueStateEvents.length) {
      setCxQueueStateEvents((events) => events.slice(1));
    }
  }, [cxQueueStateEvents, agentsLoaded]);

  useEffect(() => {
    setProcessingState(cxStateEvents[0]);
  }, [cxStateEvents]);

  useEffect(() => {
    if (me === undefined) {
      return;
    }
    if (origin === undefined) {
      return;
    }

    const meCX = cxStateEvents?.reduce((sum, stateEvent) => {
      if (stateEvent.agentId !== me.agentId.toString()) {
        return sum;
      }

      if (sum?.dateTime && stateEvent.dateTime < sum.dateTime) {
        return sum;
      }

      return stateEvent;
    }, undefined as CXAgentState | undefined);
  }, [cxStateEvents, me, origin]);

  useEffect(() => {
    setProcessingQueueState(cxQueueStateEvents[0]);
  }, [cxQueueStateEvents]);

  useEffect(() => {
    const item = processingQueueState;

    if (item === undefined || !agentsLoaded) {
      return;
    }

    setCxAgents((oldAgents) =>
      oldAgents?.map((agent) => {
        if (agent?.agentId?.toString() === item?.agentId?.toString()) {
          const newQueues = agent.queues?.map((queue) => {
            const newLogin = item.update.find(
              (q) => q.queueId.toString() === queue.queueId.toString()
            )?.login;

            return {
              ...queue,
              login: newLogin !== undefined ? newLogin : queue.login,
            };
          });
          return {
            ...agent,
            queues: newQueues,
          };
        }
        return agent;
      })
    );
  }, [processingQueueState]);
  //   console.log("cx agents", cxAgents);
  useEffect(() => {
    const item = processingState;
    console.log("processing state item", item);

    if (item === undefined || !agentsLoaded) {
      console.log("return");
      return;
    }

    setCxAgents((oldAgents) =>
      oldAgents?.map((agent) => {
        if (agent.agentId === undefined) return agent;
        if (
          agent.agentId.toString() === item.agentId.toString() &&
          (agent.stateTimestamp === undefined ||
            new Date(agent.stateTimestamp).getTime() <
              new Date(item.dateTime).getTime() ||
            (new Date(agent.stateTimestamp).getTime() ===
              new Date(item.dateTime).getTime() &&
              agent.agentState === item.previousState))
        ) {
          return {
            ...agent,
            stateTimestamp: item.dateTime,
            agentState: item.agentState,
          };
        }
        return agent;
      })
    );
  }, [processingState]);

  const sortAgents = useCallback(
    (myUsers: Array<CXAgent>) => {
      const newUsers = [...myUsers];
      const newSortedUsers = newUsers.sort((a, b) => {
        if (userSortField === "first-name") {
          if (a.firstName !== undefined && b.firstName !== undefined) {
            return a.firstName > b.firstName
              ? 1 * userSortOrder
              : -1 * userSortOrder;
          }
          return 0;
        }
        if (userSortField === "last-name") {
          if (a.lastName !== undefined && b.lastName !== undefined) {
            return a.lastName > b.lastName
              ? 1 * userSortOrder
              : -1 * userSortOrder;
          }
          return 0;
        }

        if (userSortField === "state") {
          if (a.agentState !== undefined && b.agentState !== undefined) {
            if (a.agentState > b.agentState) {
              return 1 * userSortOrder;
            }
            if (a.agentState < b.agentState) {
              return -1 * userSortOrder;
            }
            return 0;
          }
        }
        return 0;
      });

      return newSortedUsers;
    },
    [userSortField, userSortOrder]
  );

  const sortQueues = useCallback(
    (myQueues: CXQueue[]) => {
      const newQueues = [...myQueues];
      const newSortedQueues = newQueues.sort((a, b) => {
        if (queueSortField === "name") {
          if (a.gateName !== undefined && b.gateName !== undefined) {
            return a.gateName > b.gateName
              ? 1 * queueSortOrder
              : -1 * queueSortOrder;
          }
          return 0;
        }

        return 0;
      });

      return newSortedQueues;
    },
    [queueSortField, queueSortOrder]
  );

  const sortAgentGroups = useCallback(
    (myAgentGroups: CXAgentGroup[]) => {
      const newGroups = [...myAgentGroups];
      const newSortedGroups = newGroups.sort((a, b) => {
        if (a.groupName !== undefined && b.groupName !== undefined) {
          return a.groupName > b.groupName
            ? 1 * agentGroupSortOrder
            : -1 * agentGroupSortOrder;
        }
        return 0;
      });

      return newSortedGroups;
    },
    [agentGroupSortOrder]
  );

  const sortQueueGroups = useCallback(
    (myGroups: CXQueueGroup[]) => {
      const newGroups = [...myGroups];
      const newSortedGroups = newGroups.sort((a, b) => {
        if (a.groupName !== undefined && b.groupName !== undefined) {
          return a.groupName > b.groupName
            ? 1 * queueGroupSortOrder
            : -1 * queueGroupSortOrder;
        }
        return 0;
      });

      return newSortedGroups;
    },
    [queueGroupSortOrder]
  );

  const sortDepartments = useCallback(
    (myDepartments: CXDepartment[]) => {
      const newDepartments = [...myDepartments];
      const newSortedDepartments = newDepartments.sort((a, b) => {
        if (a.name !== undefined && b.name !== undefined) {
          return a.name > b.name
            ? 1 * departmentSortOrder
            : -1 * departmentSortOrder;
        }
        return 0;
      });

      return newSortedDepartments;
    },
    [departmentSortOrder]
  );

  const sortSites = useCallback(
    (mySites: CXSite[]) => {
      const newSites = [...mySites];
      const newSortedSites = newSites.sort((a, b) => {
        if (a.name !== undefined && b.name !== undefined) {
          return a.name > b.name ? 1 * siteSortOrder : -1 * siteSortOrder;
        }
        return 0;
      });

      return newSortedSites;
    },
    [siteSortOrder]
  );

  const sortSupervisors = useCallback(
    (mySupers: Array<CXSupervisor>) => {
      const newSupers = [...mySupers];
      const newSortedSupers = newSupers.sort((a, b) => {
        if (supervisorSortField === "first-name") {
          if (a.firstName !== undefined && b.firstName !== undefined) {
            return a.firstName > b.firstName
              ? 1 * supervisorSortOrder
              : -1 * supervisorSortOrder;
          }
          return 0;
        }
        if (supervisorSortField === "last-name") {
          if (a.lastName !== undefined && b.lastName !== undefined) {
            return a.lastName > b.lastName
              ? 1 * supervisorSortOrder
              : -1 * supervisorSortOrder;
          }
          return 0;
        }

        return 0;
      });

      return newSortedSupers;
    },
    [supervisorSortField, supervisorSortOrder]
  );

  const agentFilterPass = useCallback(
    (myAgent: CXAgent) => {
      let statusFilterPass;

      if (myAgent.agentState === "AVAILABLE") {
        statusFilterPass = showAvailable;
      } else if (myAgent.agentState === "OFF-LINE") {
        statusFilterPass = showOffline;
      } else if (myAgent.agentState === undefined) {
        statusFilterPass = showUnknown;
      } else if (myAgent.agentState === "ENGAGED") {
        statusFilterPass = showEngaged;
      } else if (myAgent.agentState === "BREAK-AFTER-CALL") {
        statusFilterPass = showBreakAfterCall;
      } else if (myAgent.agentState === "PENDING-DISPOSITION") {
        statusFilterPass = showPendingDisp;
      } else if (myAgent.agentState === "TRANSITION") {
        statusFilterPass = showTransition;
      } else if (myAgent.agentState === "RNA-STATE") {
        statusFilterPass = showRna;
      } else if (myAgent.agentState === "ON-BREAK") {
        statusFilterPass = showOnBreak;
      } else if (myAgent.agentState === "AWAY") {
        statusFilterPass = showAway;
      } else if (myAgent.agentState === "LUNCH") {
        statusFilterPass = showLunch;
      } else if (myAgent.agentState === "TRAINING") {
        statusFilterPass = showTraining;
      } else if (myAgent.agentState === "WORKING") {
        statusFilterPass = showWorking;
      } else {
        statusFilterPass =
          showOnBreak &&
          showAway &&
          showLunch &&
          showTraining &&
          showWorking &&
          showRna;
      }

      const queueFilterPass =
        !excludedUsers.has(myAgent.id) && !blockedUsers.has(myAgent.id);
      const myQueues = myAgent.queues;
      const noQueueFilterPass =
        showNoQueues ||
        (!showNoQueues && myQueues !== undefined && myQueues.length !== 0);
      return statusFilterPass && queueFilterPass && noQueueFilterPass;
    },
    [
      blockedUsers,
      excludedUsers,
      showAvailable,
      showAway,
      showBreakAfterCall,
      showEngaged,
      showLunch,
      showNoQueues,
      showOffline,
      showOnBreak,
      showRna,
      showTraining,
      showTransition,
      showWorking,
      showUnknown,
      showPendingDisp,
    ]
  );

  const getVisibleAgents = useCallback(() => {
    const newVisibleAgents = [] as Array<CXAgent>;
    cxAgents
      ?.filter((myAgent) => agentFilterPass(myAgent))
      .forEach((agent) => {
        const agentQueues = agent.queues?.filter(
          (queue) =>
            !excludedQueues.has(queue.queueId.toString()) &&
            !blockedQueues.has(queue.queueId.toString())
        );

        const myExtension = extensions?.find(
          (extension) => extension.extensionId === agent.agentId.toString()
        );
        const myActiveCalls = myExtension?.activePhoneNumbers;
        const myRingingCalls = myExtension?.ringingPhoneNumbers;

        newVisibleAgents.push({
          ...agent,
          queues: agentQueues,
          activeCalls: Array.from(myActiveCalls?.values() || []),
          ringingCalls: Array.from(myRingingCalls?.values() || []),
          callState: myExtension?.state,
        });
      });

    return newVisibleAgents;
  }, [agentFilterPass, cxAgents, blockedQueues, excludedQueues, extensions]);

  useEffect(() => {
    setVisibleAgents(sortAgents(getVisibleAgents()));
  }, [
    sortAgents,
    sortQueues,
    cxAgents,
    userSortField,
    userSortOrder,
    getVisibleAgents,
    extensions,
  ]);

  useEffect(() => {
    setRowData(
      visibleAgents?.map((agent) => ({
        agent,
        extension: extensions?.find(
          (extension) => extension.extensionId === agent.agentId.toString()
        ),
      }))
    );
  }, [visibleAgents, extensions]);

  if (cxError) {
    return null;
  }

  useEffect(() => {
    if (mode === "light") {
      setBackgroundColor("#0684bd");
      return;
    }
    setBackgroundColor("#181818");
  }, [mode]);

  useEffect(() => {
    const storedExcludedAgents = localStorage.getItem("cx-excluded-agents");
    const storedExcludedQueues = localStorage.getItem("cx-excluded-queues");
    const storedShowAgentType = localStorage.getItem("cx-show-agent-type");
    const storedShowSupervisorType = localStorage.getItem(
      "cx-show-supervisor-type"
    );
    const storedShowUnsupervised = localStorage.getItem("cx-show-unsupervised");
    const storedExcludedAgentGroups = localStorage.getItem(
      "cx-excluded-agent-groups"
    );
    const storedExcludedQueueGroups = localStorage.getItem(
      "cx-excluded-queue-groups"
    );
    const storedExcludedDepartments = localStorage.getItem(
      "cx-excluded-departments"
    );
    const storedExcludedSites = localStorage.getItem("cx-excluded-sites");
    const storedExcludedSupervisors = localStorage.getItem(
      "cx-excluded-supervisors"
    );
    const storedShowQueueAgents = localStorage.getItem("cx-show-queue-agents");

    if (storedShowQueueAgents) {
      setShowNoQueues(JSON.parse(storedShowQueueAgents));
    }
    if (storedExcludedAgents) {
      setExcludedUsers(new Set(JSON.parse(storedExcludedAgents)));
    }
    if (storedExcludedSupervisors) {
      setExcludedSupervisors(new Set(JSON.parse(storedExcludedSupervisors)));
    }
    if (storedExcludedQueues) {
      setExcludedQueues(new Set(JSON.parse(storedExcludedQueues)));
    }
    if (storedShowAgentType) {
      setShowAgentType(JSON.parse(storedShowAgentType));
    }
    if (storedShowSupervisorType) {
      setShowSupervisorType(JSON.parse(storedShowSupervisorType));
    }
    if (storedShowUnsupervised) {
      setShowUnsupervised(JSON.parse(storedShowUnsupervised));
    }
    if (storedExcludedAgentGroups) {
      setExcludedAgentGroups(new Set(JSON.parse(storedExcludedAgentGroups)));
    }
    if (storedExcludedQueueGroups) {
      setExcludedQueueGroups(new Set(JSON.parse(storedExcludedQueueGroups)));
    }
    if (storedExcludedDepartments) {
      setExcludedDepartments(new Set(JSON.parse(storedExcludedDepartments)));
    }
    if (storedExcludedSites) {
      setExcludedSites(new Set(JSON.parse(storedExcludedSites)));
    }
  }, []);

  useEffect(() => {
    const newInProgressData = Array.from(activeCalls.values())
      .filter((item): item is CXExtension => !item.ended)
      .filter(
        (call: CXExtension) =>
          queues.find((queue) => queue.id === call.extensionId) &&
          !excludedQueues.has(call.extensionId)
      )
      .map((call: CXExtension) => {
        const activeAgent = cxAgents?.find(
          (agent) => agent.id === call.activeAgent
        );
        let agentName = "";
        if (activeAgent) {
          agentName = `${activeAgent.firstName} ${activeAgent.lastName}`;
        }
        return {
          ...call,
          ...queues.find((queue) => queue.id === call.extensionId),
          agentName,
        };
      });

    setInProgressRowData(newInProgressData);
  }, [activeCalls, queues, cxAgents]);

  return (
    <>
      {/* 
      <div>
        <FormGroup row>
          <FormControlLabel
            control={
              <Checkbox
                onChange={() => setShowAvailable(!showAvailable)}
                checked={showAvailable}
              />
            }
            label="AVAILABLE"
          />
          <FormControl>
            <FormControlLabel
              control={
                <Checkbox
                  onChange={(event) =>
                    changeShowAllEngaged(event.target.checked)
                  }
                  checked={showEngaged && showBreakAfterCall && showTransition}
                />
              }
              label="ENGAGED"
            />
          </FormControl>
          <IconButton onClick={() => setEngagedExpanded(!engagedExpanded)}>
            {!engagedExpanded && <ExpandMore />}
            {engagedExpanded && <ExpandLess />}
          </IconButton>
          {engagedExpanded && (
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={() => setShowEngaged(!showEngaged)}
                    checked={showEngaged}
                  />
                }
                label="ENGAGED"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={() => setShowBreakAfterCall(!showBreakAfterCall)}
                    checked={showBreakAfterCall}
                  />
                }
                label="BREAK-AFTER-CALL"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={() => setShowTransition(!showTransition)}
                    checked={showTransition}
                  />
                }
                label="TRANSITION"
              />
            </FormGroup>
          )}
          <FormControlLabel
            control={
              <Checkbox
                onChange={(event) =>
                  changeShowUnavailable(event.target.checked)
                }
                checked={
                  showOnBreak &&
                  showAway &&
                  showLunch &&
                  showTraining &&
                  showWorking &&
                  showRna
                }
              />
            }
            label="UNAVAILABLE"
          />
          <IconButton
            onClick={() => setUnavailableExpanded(!unavailableExpanded)}
          >
            {!unavailableExpanded && <ExpandMore />}
            {unavailableExpanded && <ExpandLess />}
          </IconButton>
          {unavailableExpanded && (
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={() => setShowOnBreak(!showOnBreak)}
                    checked={showOnBreak}
                  />
                }
                label="ON-BREAK"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={() => setShowAway(!showAway)}
                    checked={showAway}
                  />
                }
                label="AWAY"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={() => setShowLunch(!showLunch)}
                    checked={showLunch}
                  />
                }
                label="LUNCH"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={() => setShowTraining(!showTraining)}
                    checked={showTraining}
                  />
                }
                label="TRAINING"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={() => setShowWorking(!showWorking)}
                    checked={showWorking}
                  />
                }
                label="WORKING"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={() => setShowRna(!showRna)}
                    checked={showRna}
                  />
                }
                label="RNA-STATE"
              />
            </FormGroup>
          )}
          <FormControlLabel
            control={
              <Checkbox
                onChange={() => setShowOffline(!showOffline)}
                checked={showOffline}
              />
            }
            label="OFFLINE"
          />
        </FormGroup>
      </div>
    */}
      <div className="cx-parent" style={{ overflow: "hidden" }}>
        <div
          style={{
            display: tab === "cx" ? "block" : "none",
          }}
          className={`cx-display-panel ${sidebar ? "open" : "closed"}`}
        >
          <div
            className={
              mode === "dark" ? "ag-theme-alpine-dark" : "ag-theme-alpine"
            }
            style={{
              margin: 5,
              marginBottom: 0,
              display: showCXLeaderboards ? "block" : "none",
            }}
          >
            <Toolbar
              disableGutters
              variant="dense"
              style={{
                minHeight: "50px",
                backgroundColor: mode === "dark" ? "#181818" : "#0684bd",
                borderRadius: "5px 5px 0px 0px",
              }}
            >
              <Grid container justifyContent="space-between">
                <Grid item xs={4} md={6}>
                  <Button
                    id="user-leaderboard-expand"
                    variant="text"
                    disableRipple
                    style={{
                      backgroundColor: "transparent",
                      color: "#fff",
                      textTransform: "none",
                      paddingTop: "0.3rem",
                    }}
                    onClick={() => {
                      localStorage.setItem(
                        "cx-leaderboard-expanded",
                        JSON.stringify(!expandedCxAgentLeaderboard)
                      );
                      setExpandedCxAgentLeaderboard(
                        !expandedCxAgentLeaderboard
                      );
                    }}
                    startIcon={
                      expandedCxAgentLeaderboard ? (
                        <ExpandLess style={{ color: "white" }} />
                      ) : (
                        <ExpandMore style={{ color: "white" }} />
                      )
                    }
                  >
                    Leaderboard
                    {activeFilterRef &&
                      Object.keys(activeFilterRef)?.length > 0 && (
                        <button
                          type="button"
                          style={{
                            cursor: "pointer",
                            background: "none",
                            border: "none",
                          }}
                        >
                          <span
                            style={{
                              fontFamily: "agGridAlpine",
                              color: "white",
                              fontSize: "1.4em",
                            }}
                            className="ag-theme-alpine ag-icon-filter"
                          />
                        </button>
                      )}
                  </Button>
                </Grid>
                {expandedCxAgentLeaderboard && (
                  <Grid
                    container
                    item
                    xs={8}
                    md={6}
                    alignItems="center"
                    direction="row-reverse"
                    style={{ paddingTop: "0.3rem" }}
                  >
                    <Grid
                      container
                      item
                      xs={12}
                      sm={12}
                      justifyContent="flex-end"
                    >
                      {/* Leaderboard Height Control Buttons */}
                      <Button
                        size="small"
                        style={{
                          height: "32px",
                          width: "32px",
                          minWidth: "24px",
                        }}
                        onClick={larger}
                      >
                        <UnfoldMore style={{ color: "white" }} />
                      </Button>
                      <Button
                        size="small"
                        style={{
                          height: "32px",
                          width: "32px",
                          minWidth: "24px",
                        }}
                        onClick={smaller}
                      >
                        <UnfoldLess style={{ color: "white" }} />
                      </Button>
                      {/* Font Control Buttons */}
                      <Button
                        onClick={increaseFont}
                        size="small"
                        style={{
                          height: "32px",
                          width: "32px",
                          minWidth: "24px",
                        }}
                      >
                        <TextFormat
                          style={{ fontSize: "1.8rem", color: "white" }}
                        />
                      </Button>
                      <Button
                        onClick={decreaseFont}
                        size="small"
                        style={{
                          height: "32px",
                          width: "32px",
                          minWidth: "24px",
                        }}
                      >
                        <TextFormat
                          fontSize="small"
                          style={{ color: "white" }}
                        />
                      </Button>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </Toolbar>
            <Collapse in={expandedCxAgentLeaderboard} timeout="auto">
              <Box style={{ display: "flex", justifyContent: "center" }}>
                <div
                  className={
                    mode === "dark" ? "ag-theme-alpine-dark" : "ag-theme-alpine"
                  }
                  style={{
                    height: `${height}vh`,
                    width: "100%",
                  }}
                >
                  <CxAgentLeaderboard
                    fontSize={fontSize}
                    myId={id}
                    rowData={rowData?.map((row) => ({
                      firstName: row.agent.firstName as string,
                      lastName: row.agent.lastName as string,
                      agentId: row.agent.agentId as number,
                      state: row?.extension?.state || ("IDLE" as string),
                      agentPresence:
                        row.agent.agentState || ("unknown" as string),
                      id: row.agent.id as string,
                      display: row.agent.display as string,
                      ...(row.extension as CXExtension),
                    }))}
                    mode={mode}
                    local={local}
                    updateLocal={updateLocal}
                    setActiveFilterRef={setActiveFilterRef}
                    page={page}
                    tab={tab}
                    selectedLeaderboard={selectedLeaderboard}
                  />
                </div>
              </Box>
            </Collapse>
          </div>
        </div>
        <div
          style={{
            display: tab === "cx-queues" ? "block" : "none",
          }}
          className={`cx-display-panel ${sidebar ? "open" : "closed"}`}
        >
          <div
            className={
              mode === "dark" ? "ag-theme-alpine-dark" : "ag-theme-alpine"
            }
            style={{
              width: "calc(100% - 10px)",
              margin: 5,
              marginBottom: 0,
              display: showCXLeaderboards ? "block" : "none",
              background: mode === "light" ? "white" : "#181818",
            }}
          >
            <Toolbar
              disableGutters
              variant="dense"
              style={{
                minHeight: "50px",
                backgroundColor: mode === "dark" ? "#181818" : "#0684bd",
                borderRadius: "5px 5px 0px 0px",
              }}
            >
              <Grid container justifyContent="space-between">
                <Grid item xs={4} md={6}>
                  <Button
                    id="user-leaderboard-expand"
                    variant="text"
                    disableRipple
                    style={{
                      backgroundColor: "transparent",
                      color: "#fff",
                      textTransform: "none",
                      paddingTop: "0.3rem",
                    }}
                    onClick={() => {
                      localStorage.setItem(
                        "cx-queue-leaderboard-expanded",
                        JSON.stringify(!expandedCxQueueLeaderboard)
                      );
                      setExpandedCxQueueLeaderboard(
                        !expandedCxQueueLeaderboard
                      );
                    }}
                    startIcon={
                      expandedCxQueueLeaderboard ? (
                        <ExpandLess style={{ color: "white" }} />
                      ) : (
                        <ExpandMore style={{ color: "white" }} />
                      )
                    }
                  >
                    Leaderboard
                    {activeFilterRef &&
                      Object.keys(activeFilterRef)?.length > 0 && (
                        <button
                          type="button"
                          style={{
                            cursor: "pointer",
                            background: "none",
                            border: "none",
                          }}
                        >
                          <span
                            style={{
                              fontFamily: "agGridAlpine",
                              color: "white",
                              fontSize: "1.4em",
                            }}
                            className="ag-theme-alpine ag-icon-filter"
                          />
                        </button>
                      )}
                  </Button>
                </Grid>
                {expandedCxQueueLeaderboard && (
                  <Grid
                    container
                    item
                    xs={8}
                    md={6}
                    alignItems="center"
                    direction="row-reverse"
                    style={{ paddingTop: "0.3rem" }}
                  >
                    <Grid
                      container
                      item
                      xs={12}
                      sm={12}
                      justifyContent="flex-end"
                    >
                      {/* Leaderboard Height Control Buttons */}
                      <Button
                        size="small"
                        style={{
                          height: "32px",
                          width: "32px",
                          minWidth: "24px",
                        }}
                        onClick={larger}
                      >
                        <UnfoldMore style={{ color: "white" }} />
                      </Button>
                      <Button
                        size="small"
                        style={{
                          height: "32px",
                          width: "32px",
                          minWidth: "24px",
                        }}
                        onClick={smaller}
                      >
                        <UnfoldLess style={{ color: "white" }} />
                      </Button>
                      {/* Font Control Buttons */}
                      <Button
                        onClick={increaseFont}
                        size="small"
                        style={{
                          height: "32px",
                          width: "32px",
                          minWidth: "24px",
                        }}
                      >
                        <TextFormat
                          style={{ fontSize: "1.8rem", color: "white" }}
                        />
                      </Button>
                      <Button
                        onClick={decreaseFont}
                        size="small"
                        style={{
                          height: "32px",
                          width: "32px",
                          minWidth: "24px",
                        }}
                      >
                        <TextFormat
                          fontSize="small"
                          style={{ color: "white" }}
                        />
                      </Button>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </Toolbar>
            <Collapse in={expandedCxQueueLeaderboard} timeout="auto" style={{}}>
              <Box
                style={{
                  display: selectedLeaderboard === "summary" ? "flex" : "none",
                  justifyContent: "center",
                }}
              >
                <div
                  className={
                    mode === "dark" ? "ag-theme-alpine-dark" : "ag-theme-alpine"
                  }
                  style={{
                    height: `${height}vh`,
                    width: "100%",
                  }}
                >
                  <CxQueueLeaderboard
                    fontSize={fontSize}
                    myId={id}
                    rowData={queues
                      .filter((queue: CXQueue) => !excludedQueues.has(queue.id))
                      .map((queue: any) => ({
                        ...queue,
                        ...extensions?.find((e) => e.extensionId === queue.id),
                      }))}
                    mode={mode}
                    local={local}
                    updateLocal={updateLocal}
                    setActiveFilterRef={setActiveFilterRef}
                    page={page}
                    tab={tab}
                    selectedLeaderboard={selectedLeaderboard}
                  />
                </div>
              </Box>
              <Box
                style={{
                  display: selectedLeaderboard === "waiting" ? "flex" : "none",
                  justifyContent: "center",
                }}
              >
                <div
                  className={
                    mode === "dark" ? "ag-theme-alpine-dark" : "ag-theme-alpine"
                  }
                  style={{
                    height: `${height}vh`,
                    width: "100%",
                  }}
                >
                  <CxQueueLeaderboardWaiting
                    fontSize={fontSize}
                    myId={id}
                    rowData={Array.from(waitingCalls.values())
                      .filter((item) => !item.ended)
                      .filter(
                        (call: CXExtension) =>
                          queues.find(
                            (queue) => queue.id === call.extensionId
                          ) && !excludedQueues.has(call.extensionId)
                      )
                      .map((call: CXExtension) => ({
                        ...call,
                        ...queues.find(
                          (queue) => queue.id === call.extensionId
                        ),
                      }))}
                    mode={mode}
                    local={local}
                    updateLocal={updateLocal}
                    setActiveFilterRef={setActiveFilterRef}
                    selectedLeaderboard={selectedLeaderboard}
                    page={page}
                    tab={tab}
                  />
                </div>
              </Box>
              <Box
                style={{
                  display:
                    selectedLeaderboard === "inProgress" ? "flex" : "none",
                  justifyContent: "center",
                  margin: 0,
                  marginTop: 0,
                }}
              >
                <div
                  className={
                    mode === "dark" ? "ag-theme-alpine-dark" : "ag-theme-alpine"
                  }
                  style={{
                    height: `${height}vh`,
                    width: "100%",
                  }}
                >
                  <CxQueueLeaderboardInProgress
                    fontSize={fontSize}
                    myId={id}
                    rowData={inProgressRowData}
                    mode={mode}
                    local={local}
                    updateLocal={updateLocal}
                    setActiveFilterRef={setActiveFilterRef}
                    selectedLeaderboard={selectedLeaderboard}
                    page={page}
                    tab={tab}
                  />
                </div>
              </Box>
            </Collapse>
          </div>
          {/* leaderboard toggles */}
          {showCXLeaderboards && (
            <Toolbar
              disableGutters
              variant="dense"
              style={{
                minHeight: "43px",
                backgroundColor: mode === "dark" ? "#181818" : "#0684bd",
                borderRadius: "0px 0px 5px 5px",
                border: mode === "dark" ? "1px solid #616161d9" : " ",
                borderTop: "0px",
                overflow: "hidden",
                display: expandedCxQueueLeaderboard ? "flex" : "none",
                marginLeft: 5,
                marginRight: 5,
              }}
            >
              <Button
                style={
                  selectedLeaderboard === "summary"
                    ? {
                        color: mode === "light" ? "white" : "#D3D3D3",
                        backgroundColor:
                          mode === "light" ? "rgb(44 164 219)" : "#282b2e",
                        borderRadius: "0px 0px 0px 5px",
                        marginLeft: 3,
                      }
                    : { marginLeft: 3 }
                }
                className={classes.tab}
                onClick={() => setSelectedLeaderboard("summary")}
              >
                Summary
              </Button>
              <div className="inv-container" style={{ position: "relative" }}>
                <Button
                  style={
                    selectedLeaderboard === "waiting"
                      ? {
                          color: mode === "light" ? "white" : "#D3D3D3",
                          backgroundColor:
                            mode === "light" ? "rgb(44 164 219)" : "#282b2e",
                          borderRadius: "0px 0px 0px 0px",
                        }
                      : {}
                  }
                  className={classes.tab}
                  onClick={() => setSelectedLeaderboard("waiting")}
                >
                  Waiting
                </Button>
              </div>
              <div className="inv-container" style={{ position: "relative" }}>
                <Button
                  style={
                    selectedLeaderboard === "inProgress"
                      ? {
                          color: mode === "light" ? "white" : "#D3D3D3",
                          backgroundColor:
                            mode === "light" ? "rgb(44 164 219)" : "#282b2e",
                          borderRadius: "0px 0px 0px 0px",
                        }
                      : {}
                  }
                  className={classes.tab}
                  onClick={() => setSelectedLeaderboard("inProgress")}
                >
                  In Progress
                </Button>
              </div>
            </Toolbar>
          )}
          {tab === "cx-queues" && (
            <div
              style={{
                display: fullscreen ? "none" : "flex",
                alignItems: "center",
                paddingTop: 10,
              }}
              className={`queue-toolbar ${
                mode === "light" ? "light-mode" : "dark-mode"
              }`}
            >
              <Button
                className="queue-bar"
                // variant="text"
                disableRipple
                style={
                  mode === "dark"
                    ? {
                        color: "white",
                        backgroundColor: "transparent",
                        height: 30,
                        textTransform: "none",
                      }
                    : {
                        color: "black",
                        height: 30,
                        backgroundColor: "transparent",
                        textTransform: "none",
                      }
                }
                onClick={() => {
                  localStorage.setItem(
                    "cx-expanded-queue-widgets",
                    JSON.stringify(!expandQueues)
                  );

                  setExpandQueues(!expandQueues);
                }}
                startIcon={
                  expandQueues ? (
                    <ExpandLess
                      style={mode === "dark" ? { color: "white" } : {}}
                    />
                  ) : (
                    <ExpandMore
                      style={mode === "dark" ? { color: "white" } : {}}
                    />
                  )
                }
              >
                Queues
              </Button>
              {expandQueues && (
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    className={`compact-view-selector-container ${
                      mode === "light" ? "light-mode" : "dark-mode"
                    }`}
                  >
                    {/* <button type="button" className={`compact-view-selector ${mode === 'light' ? "light" : "dark"}`} onClick={() => handleQueueCompactView(false)}>
                          <Apps   /> Widget View
                        </button>
                        <button type="button" className={`compact-view-selector ${mode === 'light' ? "light" : "dark"}`} onClick={() => handleQueueCompactView(true)}>
                          <Reorder   /> Compact View
                        </button> */}
                  </div>
                  <button
                    type="button"
                    className={`compact-view-selector-item ${
                      mode === "light" ? "light" : "dark"
                    }`}
                    onClick={() =>
                      setFullscreen((prev) =>
                        prev === "cx-queues" ? undefined : "cx-queues"
                      )
                    }
                    color={mode === "light" ? "black" : "white"}
                  >
                    <Fullscreen
                      style={{ color: mode === "light" ? "#0684bd" : "white" }}
                    />
                    Fullscreen
                  </button>
                </span>
              )}
            </div>
          )}
          {/* <Button
            className="queue-bar"
            variant="text"
            disableRipple
            style={
              mode === "dark"
                ? {
                    color: "white",
                    backgroundColor: "transparent",
                  }
                : {
                    color: "black",
                    backgroundColor: "transparent",
                  }
            }
            onClick={() => {
              localStorage.setItem(
                "cx-expanded-queue-widgets",
                JSON.stringify(!expandQueues)
              );
              setExpandQueues(!expandQueues);
            }}
            startIcon={
              expandQueues ? (
                <ExpandLess style={mode === "dark" ? { color: "white" } : {}} />
              ) : (
                <ExpandMore style={mode === "dark" ? { color: "white" } : {}} />
              )
            }
          >
            Queues
          </Button> */}
          <Collapse
            in={expandQueues}
            timeout="auto"
            style={{
              width: "calc(100% - 8px)",
            }}
          >
            <div
              className={`${fullscreen === "cx-queues" ? "fullscreen" : ""} ${
                mode === "light" ? "light" : "dark"
              }`}
              style={{ zIndex: 1000000000000000, background: "transparent" }}
            >
              {fullscreen === "cx-queues" && (
                <CompactViewHeader
                  closeFullscreen={() => setFullscreen(undefined)}
                  mode={mode}
                />
              )}
              <Grid
                container
                spacing={1}
                style={{
                  marginTop: 10,
                  paddingLeft: 10,
                }}
              >
                {queues
                  ?.filter((queue) => !excludedQueues.has(queue.id))
                  .map((queue) => (
                    <CxQueueWidget
                      key={queue.id}
                      queue={queue}
                      extension={extensions?.find(
                        (extension) => extension.extensionId === queue.id
                      )}
                      agents={rowData?.filter((agent) =>
                        agent?.agent?.queues?.some(
                          (agentQueue) =>
                            agentQueue.queueId.toString() ===
                            queue.id.toString()
                        )
                      )}
                      offset={offset}
                      mode={mode}
                      checked={!!checkedQueues?.has(queue.id.toString())}
                      setCheckedQueues={setCheckedQueues}
                      sidebar={sidebar}
                      tab={tab}
                      longestWaitingEvents={Array.from(
                        longestWaiting.values()
                      ).filter((event) => event.extensionId === queue.id)}
                    />
                  ))}
              </Grid>
              {tab === "cx-queues" && (
                <Grid
                  container
                  spacing={1}
                  style={{
                    marginTop: 10,
                    paddingLeft: 10,
                  }}
                >
                  {visibleAgents
                    ?.filter((agent) =>
                      agent.queues?.find((queue) =>
                        checkedQueues?.has(queue.queueId.toString())
                      )
                    )
                    .map((agent) => ({
                      ...agent,
                      exEmergency: historicalUsers?.find(
                        (hu: any) => hu.id === agent.rcUserId
                      )?.emergency,
                    }))
                    ?.sort((a, b) => {
                      if (a?.exEmergency === b?.exEmergency) {
                        return 0;
                      }
                      return a?.exEmergency ? -1 : 1;
                    })
                    .map((agent, i) => (
                      <CxAgent
                        key={agent.id}
                        origin={origin}
                        backgroundWeight={backgroundWeight}
                        agent={agent}
                        sidebar={sidebar}
                        rcId={rcId}
                        i={i}
                        color={color}
                        classes={classes}
                        colorWeight={colorWeight}
                        formatDuration={formatDuration}
                        formatApproxDuration={formatApproxDuration}
                        formatDailyDuration={formatDailyDuration}
                        elapsedTime={elapsedTime}
                        offset={offset}
                        extension={extensions?.find(
                          (extension) => extension.extensionId === agent.id
                        )}
                        organizationId={organizationId}
                        isAdmin={isAdmin}
                        apiUrl={apiUrl}
                        historicalUsers={historicalUsers}
                        handIsRaised={agent.exEmergency}
                        displayPortraits={displayPortraits}
                        vipList={vipList}
                        setProfileId={setProfileId}
                        setPage={setPage}
                        adminclick={adminclick}
                        mode={mode}
                      />
                    ))}
                </Grid>
              )}
            </div>
          </Collapse>
        </div>

        <div
          className={`cx-sidebar ${sidebar ? "open" : "closed"}`}
          style={{
            marginTop: 110,
            background: mode === "light" ? "#0684bd" : "#181818",
          }}
        >
          <CxSidebar
            showAvailable={showAvailable}
            setShowAvailable={setShowAvailable}
            showAway={showAway}
            showOffline={showOffline}
            showWorking={showWorking}
            setShowLunch={setShowLunch}
            showLunch={showLunch}
            setShowOnBreak={setShowOnBreak}
            showOnBreak={showOnBreak}
            showTraining={showTraining}
            showEngaged={showEngaged}
            showTransition={showTransition}
            showRna={showRna}
            showBreakAfterCall={showBreakAfterCall}
            showUnknown={showUnknown}
            showPendingDisp={showPendingDisp}
            setShowOffline={setShowOffline}
            setShowAway={setShowAway}
            setShowTraining={setShowTraining}
            setShowWorking={setShowWorking}
            setShowPendingDisp={setShowPendingDisp}
            setShowEngaged={setShowEngaged}
            setShowTransition={setShowTransition}
            setShowRna={setShowRna}
            setShowBreakAfterCall={setShowBreakAfterCall}
            setShowUnknown={setShowUnknown}
            organizationId={organizationId}
            page={page}
            activeFilterRef={activeFilterRef}
            users={cxAgents}
            queues={queues}
            agentGroups={agentGroups}
            queueGroups={queueGroups}
            departments={departments}
            supervisors={supervisors}
            sites={sites}
            sortAgents={sortAgents}
            sortQueues={sortQueues}
            sortAgentGroups={sortAgentGroups}
            sortQueueGroups={sortQueueGroups}
            sortSupervisors={sortSupervisors}
            sortDepartments={sortDepartments}
            sortSites={sortSites}
            blockedUsers={blockedUsers}
            setBlockedUsers={setBlockedUsers}
            excludedUsers={excludedUsers}
            setExcludedUsers={setExcludedUsers}
            excludedQueues={excludedQueues}
            setExcludedQueues={setExcludedQueues}
            blockedQueues={blockedQueues}
            setBlockedQueues={setBlockedQueues}
            blockedAgentGroups={blockedAgentGroups}
            setBlockedAgentGroups={setBlockedAgentGroups}
            excludedAgentGroups={excludedAgentGroups}
            setExcludedAgentGroups={setExcludedAgentGroups}
            blockedQueueGroups={blockedQueueGroups}
            setBlockedQueueGroups={setBlockedQueueGroups}
            excludedQueueGroups={excludedQueueGroups}
            setExcludedQueueGroups={setExcludedQueueGroups}
            blockedDepartments={blockedDepartments}
            setBlockedDepartments={setBlockedDepartments}
            blockedSites={blockedSites}
            setBlockedSites={setBlockedSites}
            excludedDepartments={excludedDepartments}
            setExcludedDepartments={setExcludedDepartments}
            excludedSites={excludedSites}
            setExcludedSites={setExcludedSites}
            userSortField={userSortField}
            userSortOrder={userSortOrder}
            queueSortField={queueSortField}
            queueSortOrder={queueSortOrder}
            agentGroupSortOrder={agentGroupSortOrder}
            queueGroupSortOrder={queueGroupSortOrder}
            setAgentGroupSortOrder={setAgentGroupSortOrder}
            setQueueGroupSortOrder={setQueueGroupSortOrder}
            setDepartmentSortOrder={setDepartmentSortOrder}
            departmentSortOrder={departmentSortOrder}
            siteSortOrder={siteSortOrder}
            setSiteSortOrder={setSiteSortOrder}
            setUserSortField={setUserSortField}
            setUserSortOrder={setUserSortOrder}
            setQueueSortField={setQueueSortField}
            setQueueSortOrder={setQueueSortOrder}
            showNoQueues={showNoQueues}
            setShowNoQueues={setShowNoQueues}
            showAgentType={showAgentType}
            setShowAgentType={setShowAgentType}
            showSupervisorType={showSupervisorType}
            setShowSupervisorType={setShowSupervisorType}
            blockedSupervisors={blockedSupervisors}
            setBlockedSupervisors={setBlockedSupervisors}
            excludedSupervisors={excludedSupervisors}
            setExcludedSupervisors={setExcludedSupervisors}
            supervisorSortOrder={supervisorSortOrder}
            setSupervisorSortOrder={setSupervisorSortOrder}
            supervisorSortField={supervisorSortField}
            setSupervisorSortField={setSupervisorSortField}
            showUnsupervised={showUnsupervised}
            setShowUnsupervised={setShowUnsupervised}
            mode={mode}
            setDisplayPortraits={setDisplayPortraits}
            displayPortraits={displayPortraits}
          />
        </div>
        {tab === "cx" && (
          <div
            style={{
              display: fullscreen ? "none" : "flex",
              alignItems: "center",
              paddingTop: 10,
            }}
            className={`queue-toolbar ${
              mode === "light" ? "light-mode" : "dark-mode"
            } ${sidebar ? "sidebar-open" : ""}`}
          >
            <Button
              className="queue-bar"
              // variant="text"
              disableRipple
              style={
                mode === "dark"
                  ? {
                      color: "white",
                      backgroundColor: "transparent",
                      height: 30,
                      textTransform: "none",
                    }
                  : {
                      color: "black",
                      height: 30,
                      backgroundColor: "transparent",
                      textTransform: "none",
                    }
              }
              onClick={() => {
                localStorage.setItem(
                  "cx-expanded-queue-agents",
                  JSON.stringify(!expandAgents)
                );

                setExpandAgents(!expandAgents);
              }}
              startIcon={
                expandAgents ? (
                  <ExpandLess
                    style={mode === "dark" ? { color: "white" } : {}}
                  />
                ) : (
                  <ExpandMore
                    style={mode === "dark" ? { color: "white" } : {}}
                  />
                )
              }
            >
              Agents
            </Button>
            {expandQueues && (
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                <div
                  className={`compact-view-selector-container ${
                    mode === "light" ? "light-mode" : "dark-mode"
                  }`}
                >
                  {/* <button type="button" className={`compact-view-selector ${mode === 'light' ? "light" : "dark"}`} onClick={() => handleQueueCompactView(false)}>
                          <Apps   /> Widget View
                        </button>
                        <button type="button" className={`compact-view-selector ${mode === 'light' ? "light" : "dark"}`} onClick={() => handleQueueCompactView(true)}>
                          <Reorder   /> Compact View
                        </button> */}
                </div>
                <button
                  type="button"
                  className={`compact-view-selector-item ${
                    mode === "light" ? "light" : "dark"
                  }`}
                  onClick={() =>
                    setFullscreen((prev) => (prev === "cx" ? undefined : "cx"))
                  }
                  color={mode === "light" ? "black" : "white"}
                >
                  <Fullscreen
                    style={{ color: mode === "light" ? "#0684bd" : "white" }}
                  />
                  Fullscreen
                </button>
              </span>
            )}
          </div>
        )}
        <Collapse in={expandAgents}>
          <div
            className={`${fullscreen === "cx" ? "fullscreen" : ""} ${
              mode === "light" ? "light" : "dark"
            }`}
            style={{ zIndex: 1000000000000000, background: "transparent" }}
          >
            {fullscreen === "cx" && (
              <CompactViewHeader
                closeFullscreen={() => setFullscreen(undefined)}
                mode={mode}
              />
            )}
            <Grid
              container
              spacing={1}
              style={{
                marginTop: 10,
                paddingLeft: 10,
                // background: mode === 'light' ? "white" : "#282828"
              }}
              className={`cx-display-panel ${sidebar ? "open" : "closed"}`}
            >
              {tab === "cx" &&
                visibleAgents
                  .map((agent) => ({
                    ...agent,
                    exEmergency: historicalUsers.find(
                      (hu: any) => hu.id === agent.rcUserId
                    )?.emergency,
                  }))
                  ?.sort((a, b) => {
                    if (a?.exEmergency === b?.exEmergency) {
                      return 0;
                    }
                    return a?.exEmergency ? -1 : 1;
                  })
                  ?.map((agent, i) => (
                    <CxAgent
                      key={agent.id}
                      origin={origin}
                      setProfileId={setProfileId}
                      backgroundWeight={backgroundWeight}
                      agent={agent}
                      sidebar={sidebar}
                      rcId={rcId}
                      i={i}
                      color={color}
                      classes={classes}
                      colorWeight={colorWeight}
                      formatDuration={formatDuration}
                      formatApproxDuration={formatApproxDuration}
                      formatDailyDuration={formatDailyDuration}
                      elapsedTime={elapsedTime}
                      offset={offset}
                      organizationId={organizationId}
                      isAdmin={isAdmin}
                      apiUrl={apiUrl}
                      historicalUsers={historicalUsers}
                      extension={extensions?.find(
                        (extension) => extension.extensionId === agent.id
                      )}
                      handIsRaised={agent.exEmergency}
                      displayPortraits={displayPortraits}
                      vipList={vipList}
                      setPage={setPage}
                      adminclick={adminclick}
                      mode={mode}
                    />
                  ))}
            </Grid>
          </div>
        </Collapse>
      </div>
    </>
  );
}

export type {
  CXAgent,
  CXQueue,
  CXAgentState,
  CXQueueState,
  CXAgentGroup,
  CXQueueGroup,
  CXSupervisor,
};
